export const es = {
  translation: {
    // WebChat
    chat_with_provider: 'Chatear con proveedor',
    //Main Menu

    menu_messages: 'Mensajes',
    menu_household: 'Familia',
    menu_my_profile: 'Perfil médico',
    menu_settings: 'Configuración',
    menu_log_out: 'Cerrar sesión',

    // Register Section

    register_title2: 'Empecemos',
    register_subtitle2:
      'Solicitamos tu nombre y fecha de nacimiento para confirmar tu identidad y proteger tu información personal.',
    register_agree: 'Al registrarme, acepto los',
    register_terms: 'Términos y Condiciones',
    register_privacy: 'Política de Privacidad',
    register_and: 'y acepto la',
    register_newsletter: 'Me gustaría suscribirme al boletín de TapTelehealth',
    register_continue_button: 'Continuar',
    register_have_already: 'Ya tenes una cuenta?',
    continue_with_google: 'Continuar con Google',
    or: 'O',

    log_in_account_question: '¿Aún no tienes una cuenta?',
    log_in_sign_up: 'Registrarme',

    // Home Dashboard

    welcome:
      '¡Bienvenido a Tap Telehealth! A continuación, algunos pasos para ayudarnos a brindarte una mejor atención a ti y a tu familia.',
    hello: 'Hola',
    need_med_care_title: 'Buscas atención médica?',
    need_med_care_text:
      'Envía un mensaje de inmediato a uno de nuestros proveedores para cualquier necesidad de atención médica que no sea una emergencia.',
    text_doctor_button: 'Chatea con un doctor',
    complete_profile_title: 'Completa tu perfil médico',
    complete_profile_description:
      'Detalla tu perfil médico para que tu atención sea más fluida, rápida y personalizada cuando nos envíes un mensaje.',
    start_button: 'Comenzar',

    //Quick Access

    quick_access_title: 'Acceso rápido',
    gs_card_1_title: 'Completa tu perfil médico',
    gs_card_2_title: 'Configura tus objetivos de salud',
    gs_card_3_title: 'Revisa tu progreso',

    quick_access_1_title: 'Administra tu hogar',
    quick_access_1_text:
      'Agrega a los miembros de la familia y completa sus perfiles médicos para asegurarte de que estén listos para recibir atención sin problemas.',
    quick_access_1_cta: 'Administrar hogar',

    quick_access_2_title: 'Revisar historial',
    quick_access_2_text:
      'Accede fácilmente a sesiones pasadas, recetas, referencias, notas de excusa y más en un solo lugar conveniente.',
    quick_access_2_cta: 'Ver historial',

    quick_access_3_title: 'Aprende más',
    quick_access_3_text:
      'Descubre más sobre TapTelehealth y las muchas maneras en que podemos apoyar tu viaje de salud.',
    quick_access_3_cta: 'Aprender más sobre Tap Telehealth',

    // Household

    household_title: 'Familia',
    household_add_pharmacy_banner_title: 'Agregar farmacia preferida',
    household_add_pharmacy_banner_description:
      'Comparte la información de tu farmacia preferida para ayudarnos a enviar recetas a la ubicación más conveniente para ti.',
    household_add_pharmacy_banner_cta: 'INICIAR',
    household_s_member: 'miembro de la familia',
    household_members: 'Miembros de la familia',
    household_add: 'Agregar',
    household_member: 'Menor',
    household_preferred_pharmacies_title: 'Farmacia preferida',
    household_owner: 'Titular del hogar',
    self: 'Yo',
    address_not_available: 'Dirección no disponible',
    before_change_address_title: 'Antes de cambiar tu dirección',
    before_change_address_body:
      'Actualizar tu dirección se aplicará a todos los miembros de tu hogar. Si deseas cambiar tu dirección solo para ti, primero debes salir de este hogar.',
    leave_this_household: 'Salir de este hogar',
    change_address_for_everyone: 'Cambiar dirección para todos',
    change_your_address_title: 'Cambia tu dirección',
    household_add_member_rights_notice:
      'Al agregar un menor a tu hogar, confirmas que tienes el derecho legal para administrar su información médica y personal. Esto incluye actuar como su padre, tutor legal o representante autorizado.',
    household_added_to_your_household: '¡{{name}} fue agregado a tu hogar!',
    household_add_another_member: 'Agregar otro miembro del hogar',

    //Settings

    settings_title: 'Configuración',
    settings_smenu_login_security: 'Inicio de sesión y seguridad',
    settings_smenu_household: 'Familia',
    settings_smenu_billing: 'Facturación',
    settings_smenu_notifications_privacy: 'Notificaciones y privacidad',
    settings_email_preferences_card_title: 'Preferencias de email',
    settings_email_preferences_card_subtitle: 'Actualizaciones y ofertas',
    settings_email_preferences_card_description:
      'Recibe actualizaciones sobre nuestros servicios, ofertas especiales y consejos de salud.',
    settings_sms_preferences_card_title: 'Mensajes SMS',
    settings_sms_preferences_card_subtitle:
      'Información general de salud y actualizaciones relacionadas con el servicio',
    settings_sms_preferences_card_description:
      'Activa esto si deseas recibir mensajes de texto de Tap Telehealth sobre recordatorios de salud pública, actualizaciones del servicio y contenido educativo. Pueden aplicarse tarifas de mensajes y datos. Puedes cambiar tus preferencias en cualquier momento. Estos mensajes son opcionales y no son necesarios para usar los Servicios de Tap Telehealth.',
    settings_privacy_card_title: 'Privacidad',
    settings_privacy_card_subtitle: 'Acuerdo de privacidad (HIPAA)',
    settings_privacy_card_description:
      'Entiendo que Tap Telehealth puede no cumplir completamente con HIPAA. Al usar este servicio, acepto los riesgos asociados y doy mi consentimiento para el uso de mi información de salud según sea necesario para los servicios de telemedicina.',
    settings_privacy_card_subtitle2: 'Acuerdo de privacidad (HIPAA)',
    settings_privacy_card_description2:
      'Comprende los términos que rigen el uso de nuestra plataforma y servicios para garantizar cumplimiento y transparencia.',
    settings_privacy_card_terms_link: 'Leer Términos de Uso',
    settings_privacy_card_subtitle3: 'Política de privacidad',
    settings_privacy_card_description3:
      'Descubre cómo recopilamos, usamos y protegemos tu información personal, y comprende tus derechos de privacidad.',
    settings_privacy_card_policy_link: 'Leer Política de Privacidad',

    settings_billing_card_title: 'Facturación',
    settings_billing_card_subtitle:
      'Tu servicio de TapTelehealth se factura cómodamente a través de tu proveedor de servicios públicos, lo que hace que sea simple y sin complicaciones mantenerse conectado con una atención médica de calidad.',
    settings_billing_card_subtitle2:
      'Si ya no estás interesado en aprovechar este servicio, aprende cómo darte de baja haciendo clic en el enlace a continuación.',
    settings_billing_card_cta: 'Más información',

    settings_account_deletion_card_title: 'Eliminar cuenta',
    settings_account_deletion_card_description:
      'Al eliminar tu cuenta, todos tus registros médicos, información de sesiones pasadas, perfiles de menores y datos asociados serán eliminados de forma permanente. Esta acción no se puede deshacer.',
    settings_account_deletion_card_subtitle: 'Cuenta',
    settings_account_deletion_card_cta: 'Eliminar',

    //Footer

    footer_contact: 'CONTACTO',
    footer_how_it_works: 'Cómo Funciona',
    footer_what_we_treat: 'Qué Tratamos',
    footer_about: 'Acerca nuestro',
    footer_blog: 'Blog',
    footer_partner: 'Asociate con nosotros',

    // Miscellaneous
    back: 'Volver',
    edit: 'Editar',
    cancel: 'Cancelar',
    update: 'Actualizar',
    save: 'Guardar',
    delete: 'Eliminar',
    done: 'Listo',
    next: 'Siguiente',
    continue: 'Continuar',
    skip_for_now: 'Omitir por ahora',
    search: 'Buscar',
    add: 'Agregar',
    added: 'Agregado',
    miles: 'millas',
    yes_remove: 'Sí, eliminar',
    yes_add: 'Sí, agregar {{item}}',
    loading: 'Cargando',
    yes: 'Sí',
    no: 'No',
    na: 'N/A',
    unknown: 'Desconocido',
    are_you_sure: '¿Estás seguro?',
    remove_household_member_confirm: '¿Deseas eliminar a este miembro del hogar?',
    remove_pharmacy_confirm:
      '¿Estás seguro de que deseas eliminar esta farmacia de la lista de farmacias preferidas de tu hogar?',
    please_enter_first_name: 'Por favor, ingresa el nombre',
    please_enter_middle_name: 'Por favor, ingresa el segundo nombre (si corresponde)',
    please_enter_last_name: 'Por favor, ingresa el apellido',
    must_be_younger_18: 'Debe ser menor de 18 años',
    must_be_18_or_older: 'Debe tener 18 años o más',

    // Menu additions
    menu_home: 'Inicio',
    drawer_menu_title: 'Menú',
    menu_open: 'Abrir menú',

    // Alts and misc
    alt_logo: 'Logo',
    alt_profile_icon: 'Ícono de perfil',
    time_8_min: '8 min',

    // Demographics Module
    terms_of_use: 'Términos y Condiciones',
    privacy_policy: 'Política de Privacidad',
    and: 'y',
    sign_up: 'Registrarme',

    demographics_setup_title: '¡Vamos a configurarte!',
    demographics_first_name: 'Nombre',
    demographics_middle_name: 'Segundo nombre',
    demographics_last_name: 'Apellido',
    demographics_full_name: 'Nombre completo',
    demographics_email: 'Correo electrónico',
    demographics_dob: 'Fecha de nacimiento',
    demographics_dob_placeholder: 'MM/DD/AAAA',
    demographics_gender: 'Género',
    demographics_gender_male: 'Masculino',
    demographics_gender_female: 'Femenino',
    demographics_gender_other: 'Otro',
    demographics_gender_unknown: 'Desconocido',
    demographics_street_address: 'Dirección',
    demographics_address_line_2: 'Departamento / Piso (opcional)',
    demographics_city: 'Ciudad',
    demographics_zip_code: 'Código postal',
    demographics_state: 'Estado',
    demographics_current_state: 'Estado en el que te encuentras',
    demographics_address: 'Dirección',
    demographics_use_current_location: 'Usar mi ubicación actual',
    demographics_continue: 'Continuar',
    demographics_error_current_location: 'No se pudo obtener tu ubicación actual',
    demographics_add_address_manually: 'Agregar manualmente',

    demographics_consent_title: 'Solo una verificación rápida de consentimiento',
    demographics_consent_body_line1:
      'Los mensajes de texto, al igual que las llamadas telefónicas y los buzones de voz, pueden no ser 100% seguros según tu servicio móvil. Puedes revisar nuestras <a>Prácticas de Privacidad de Mensajería</a> para más detalles.',
    demographics_consent_body_line2:
      'Tu atención hoy se brindará a través de telemedicina (texto, teléfono o video) en lugar de en persona. Se han explicado los riesgos, beneficios y alternativas —incluido tu derecho a detenerte en cualquier momento y buscar atención en persona—. Tu privacidad está protegida por ley, aunque ningún sistema es completamente seguro.',
    demographics_consent_body_line3:
      '¿Das tu consentimiento para comunicarte por texto y recibir atención por telemedicina hoy?',
    demographics_consent_agree: 'Estoy de acuerdo',
    demographics_consent_disagree: 'No estoy de acuerdo',
    demographics_consent_footer_prefix: 'Puedes leer nuestros',
    demographics_consent_footer_suffix: 'para más detalles.',

    demographics_confirm_title: 'Confirma tu información personal',

    // Demographics - Minor
    demographics_minor_title: 'Información del menor',
    demographics_minor_address_notice:
      'Solo podemos registrar a un menor en la misma dirección donde actualmente vive su padre, madre o tutor legal.',
    demographics_minor_success_body: 'Ahora puedes volver a tu chat con tu proveedor de Tap Telehealth.',

    demographics_no_consent_title: '¡No hay problema!',
    demographics_no_consent_body_line1:
      'Gracias por informarnos. Si prefieres no comunicarte por texto, aún puedes recibir atención hoy a través de nuestro Portal del Paciente compatible con HIPAA.',
    demographics_no_consent_body_line2: 'Tu atención seguirá brindándose por telemedicina en lugar de en persona.',
    demographics_no_consent_body_line3:
      '¿Das tu consentimiento para recibir atención por telemedicina hoy a través del Portal del Paciente?',
    demographics_no_consent_agree_portal_cta: 'Estoy de acuerdo, ir al Portal del Paciente',

    demographics_lastword_title: '¡Respetamos tu elección!',
    demographics_lastword_body_line1:
      'Entendemos y respetamos tu decisión. En este momento, Tap Telehealth solo puede brindar atención a través de telemedicina (texto, teléfono o video). Lamentablemente, hoy no podemos ofrecer servicios presenciales u otras alternativas.',
    demographics_lastword_body_line2:
      'Si lo deseas, siempre puedes volver a contactarnos cuando la telemedicina te resulte conveniente. Mientras tanto, si necesitas atención médica urgente, llama al 911 o dirígete a la sala de emergencias más cercana.',

    demographics_success_title: '¡Todo listo!',
    demographics_success_body:
      'Gracias por completar tu información. Ahora puedes volver a tu chat con tu proveedor de Tap Telehealth — están listos para ayudarte. Por favor, avísales que completaste este formulario.',
    demographics_back_to_chat: 'Volver al chat',

    // Intake
    intake_closed_title: 'Este formulario ya no está disponible',
    intake_closed_body: 'Su proveedor recopilará sus datos en el chat.',
    intake_who_title: '¿Quién necesita atención hoy?',
    intake_who_self: 'Yo',
    intake_who_self_description: 'Soy el paciente',
    intake_who_child: 'Mi hijo/a',
    intake_who_child_description: 'Soy padre, madre o tutor legal y agregaré a mi hijo/a',
    intake_under_18_link: 'Soy menor de 18 años',
    intake_under_18_notice:
      'Solo podemos atender a pacientes menores de 18 años junto con su padre, madre o tutor legal. Pídale a su padre, madre o tutor que continúe este formulario con usted, o que nos envíe un mensaje de texto desde su propio teléfono.',
    intake_under_18_confirm: 'Entiendo',
    intake_minor_success_title: 'Gracias por avisarnos',
    intake_minor_success_body:
      'Tenga a su padre, madre o tutor cerca. Un proveedor se comunicará con usted en su conversación de texto en breve.',
    intake_stepper_guardian: 'Padre, madre o tutor (usted)',
    intake_stepper_child: 'Su hijo/a',
    intake_guardian_title: 'Primero, cuéntenos sobre usted',
    intake_guardian_notice:
      'El paso 1 es sobre usted. Como padre, madre o tutor legal, usted es el titular de la cuenta. Agregará a su hijo/a en el siguiente paso.',
    intake_children_title: 'Ahora, sobre su hijo/a',
    intake_children_intro:
      'Su hijo/a compartirá su número de teléfono y domicilio. El consentimiento que usted dio se aplica en su nombre. La consulta será para su hijo/a.',
    intake_child_heading: 'Hijo/a {{number}}',
    intake_child_born: 'nacido/a el {{dob}}',
    intake_remove_child: 'Eliminar',
    intake_add_child: 'Agregar otro hijo/a',
    intake_visit_for_title: '¿Para cuál de sus hijos es esta consulta?',
    intake_visit_for_required: 'Elija para quién es esta consulta',
    intake_confirm_children: 'Hijos',
    intake_confirm_visit_for: 'Esta consulta es para',
    intake_confirm_patient: 'Paciente',
    intake_confirm_guardian: 'Padre, madre o tutor',
    intake_confirm_children_consent:
      'Como padre, madre o tutor legal, los consentimientos que dio arriba también se aplican a los hijos que agregó.',
    intake_email_in_use: 'Este correo electrónico ya está en uso. Déjelo vacío o ingrese otro.',
    intake_success_body: 'Vuelva a su conversación de texto: un proveedor lo atenderá en breve.',
    intake_adult_dob_child_hint:
      'Debe tener 18 años o más. Este formulario es sobre usted como el adulto que se comunica con nosotros. Si nos contacta por su hijo/a, deje aquí sus propios datos y agregue a su hijo/a en el siguiente paso.',

    // Demographics validation
    demographics_validation_first_name_required: 'El nombre es obligatorio',
    demographics_validation_last_name_required: 'El apellido es obligatorio',
    demographics_validation_email_invalid: 'Por favor, ingresa un correo electrónico válido',
    demographics_validation_dob_required: 'La fecha de nacimiento es obligatoria',
    demographics_validation_dob_format: 'Por favor, ingresa la fecha en formato MM/DD/AAAA',
    demographics_validation_dob_month: 'Por favor, ingresa un mes válido',
    demographics_validation_dob_day: 'Por favor, ingresa un día válido',
    demographics_validation_dob_year: 'Por favor, ingresa un año válido',
    demographics_validation_dob_future: 'La fecha de nacimiento no puede estar en el futuro',
    demographics_validation_dob_valid: 'Por favor, ingresa una fecha válida',
    demographics_validation_gender_required: 'Por favor, selecciona un género',
    demographics_validation_phone_required: 'El número de teléfono es obligatorio',
    demographics_phone: 'Número de teléfono',
    validation_numbers_only: '¡Solo se permiten números!',
    demographics_validation_address_required: 'La dirección es obligatoria',
    demographics_validation_city_required: 'La ciudad es obligatoria',
    demographics_validation_zip_required: 'El código postal es obligatorio',
    demographics_validation_state_required: 'El estado es obligatorio',
    demographics_validation_address_select: 'Por favor selecciona una dirección de las sugerencias',
    demographics_address_placeholder: 'Comienza a escribir tu dirección...',
    demographics_heard_about_service_label: '¿Cómo te enteraste por primera vez de nuestro servicio?',
    demographics_heard_about_service_other: 'Otro (por favor especifica)',
    demographics_heard_about_service_friend: 'Un amigo o familiar',
    demographics_heard_about_service_community: 'Eventos comunitarios',
    demographics_heard_about_service_social: 'Redes sociales',
    demographics_heard_about_service_google: 'Google',
    demographics_heard_about_service_specify: 'Por favor especifica cómo te enteraste de nuestro servicio',

    // Patient Portal - Medical History page and related components
    medical_history_title: 'Historial médico',
    medical_history_description:
      'Lleva un registro de tu historial médico aquí para que siempre tengamos los datos más recientes y podamos brindarte la atención más efectiva.',
    medical_history_pdf_filename: 'HistorialMedico.pdf',

    title_section_download_pdf: 'Descargar (PDF)',
    title_section_see_chat: 'Ver chat',

    sidebar_medical_history: 'Historial médico',
    sidebar_personal_info: 'Información personal',
    personal_info_general_title: 'Información general',

    // Past Sessions
    no_sessions_available: 'No hay sesiones disponibles',
    no_diagnosis_available: 'Sin diagnóstico disponible',
    past_session_label: 'Sesión pasada',
    end_of_chat_title: 'Fin del chat',
    encounter_closed_message: 'Este encuentro está cerrado. Si necesitas más ayuda, conéctate con un médico.',
    connect_me_with_doctor: 'Conectarme con un médico',
    handouts_title: 'Materiales',
    additional_notes: 'Notas adicionales',
    no_files_available: 'No hay archivos disponibles',
    excuse_notes_title: 'Notas de excusa',
    excuse_note_title_work: 'Justificante laboral',
    excuse_note_title_school: 'Justificante escolar',
    excuse_note_title_other: 'Justificante',
    excuse_note_open_error: 'No pudimos abrir este justificante. Por favor, inténtelo de nuevo.',
    no_excuse_notes_available: 'No hay notas de excusa disponibles',
    prescriptions_title: 'Recetas',
    no_prescriptions_available: 'No hay recetas disponibles',
    referrals_title: 'Referencias',
    no_referrals_available: 'No hay referencias disponibles',
    summary_title: 'Resumen',
    no_data: 'Sin datos',
    no_data_available: 'No hay datos disponibles',
    no_date_available: 'Sin fecha disponible',

    // Footer brand heading
    footer_brand_heading: 'TAP TELEHEALTH',

    // Medical History - Allergies Card
    mh_allergies_title: 'Alergias',
    mh_allergies_intro: 'Conocer tus alergias nos ayuda a ofrecer recetas más precisas y prevenir reacciones.',
    mh_allergies_yesno_question: '¿Tienes alguna alergia (medicamentos, alimentos, etc.)?',
    mh_allergies_none_label: 'Sin alergias conocidas',
    mh_allergies_add_btn: 'Agregar alergia',
    mh_allergies_none_cta: 'No tengo alergias',
    mh_allergies_form_name_label: 'Nombre',
    mh_allergies_form_name_required: 'Por favor, selecciona la alergia',
    mh_allergies_form_reaction_label: 'Reacción',
    mh_allergies_reaction_prefix: 'Reacción',

    // Medical History - Medications Card
    mh_medications_title: 'Medicamentos',
    mh_medications_intro:
      'Conocer tus medicamentos actuales nos ayuda a prevenir interacciones y brindar una atención más segura.',
    mh_medications_yesno_question:
      '¿Actualmente tomas algún medicamento de forma regular para manejar alguna condición de salud?',
    mh_medications_none_label: 'Sin medicamentos actuales',
    mh_medications_add_btn: 'Agregar medicamento',
    mh_medications_none_cta: 'No tomo medicamentos de forma regular',
    mh_medications_form_drug_label: 'Nombre del medicamento',
    mh_medications_form_drug_required: 'Por favor, selecciona el medicamento',
    mh_medications_form_dosage_label: 'Dosis',
    mh_medications_form_dosage_required: 'Por favor, ingresa la dosis',
    mh_medications_form_dosage_placeholder: 'Busca primero el medicamento para cambiar la dosis.',
    mh_medications_form_frequency_label: 'Frecuencia',

    // Medical History - Measurements Card
    mh_measurements_title: 'Medidas',
    mh_measurements_intro: 'Proporcionar tu peso y altura nos ayuda a ajustar tratamientos y dosis a tus necesidades.',
    mh_measurements_height_label: '¿Cuál es tu altura?',
    mh_measurements_height_feet_required: 'Por favor, ingresa pies',
    mh_measurements_height_feet_placeholder: 'ft',
    mh_measurements_height_inches_placeholder: 'in',
    mh_measurements_weight_label: '¿Cuál es tu peso?',
    mh_measurements_weight_required: 'Por favor, ingresa el peso',
    mh_measurements_weight_placeholder: 'lbs',
    mh_measurements_view_height: 'Altura',
    mh_measurements_view_weight: 'Peso',

    // Medical History - Health Problems Card
    mh_healthproblems_title: 'Problemas de salud',
    mh_healthproblems_intro:
      'Compartir tu historial médico nos ayuda a comprender mejor tu salud y ofrecer una atención más personalizada.',
    mh_healthproblems_none_label: 'Sin problemas de salud conocidos',
    mh_healthproblems_add_btn: 'Agregar problema de salud',
    mh_healthproblems_none_cta: 'No tengo problemas de salud',
    mh_healthproblems_other_placeholder: 'Por favor, especifica...',

    // Medical History - Family History Card
    mh_familyhistory_title: 'Antecedentes familiares',
    mh_familyhistory_intro:
      'Comprender tus antecedentes médicos familiares nos ayuda a evaluar tus riesgos de salud y brindar atención proactiva.',
    mh_familyhistory_yesno_question:
      '¿Algún miembro de tu familia tiene condiciones de salud a largo plazo (como diabetes, enfermedades del corazón u otras condiciones crónicas)?',
    mh_familyhistory_none_label: 'Sin problemas familiares conocidos',
    mh_familyhistory_add_btn: 'Agregar antecedente familiar',
    mh_familyhistory_none_cta: 'Nadie en mi familia tiene condiciones de salud a largo plazo',
    mh_familyhistory_other_placeholder: 'Por favor, especifica...',

    // Medical History - Lifestyle Card
    mh_lifestyle_title: 'Estilo de vida',
    mh_lifestyle_intro: 'Conocer tu estilo de vida nos ayuda a entender factores que impactan tu salud y atención.',
    mh_lifestyle_smoking_question:
      '¿Actualmente fumas o vapeas alguna sustancia (por ejemplo, cigarrillos, cigarrillos electrónicos u otros productos de vapeo)?',
    mh_lifestyle_yes_smoke: 'Sí, fumo',
    mh_lifestyle_yes_vape: 'Sí, vapeo',
    mh_lifestyle_yes_both: 'Sí, fumo y vapeo',
    mh_lifestyle_drinking_question: '¿Bebes alcohol?',
    mh_lifestyle_view_smoking_label: 'Fumar/Vapear',
    mh_lifestyle_view_drinking_label: 'Consumo de alcohol',
    mh_lifestyle_no_response: 'Sin respuesta',

    // Medical History - Surgical History Card
    mh_surgical_title: 'Historial quirúrgico',
    mh_surgical_intro:
      'Conocer tu historial quirúrgico nos ayuda a evitar complicaciones y garantizar un tratamiento más seguro.',
    mh_surgical_yesno_question: '¿Te has sometido a alguna cirugía en el pasado?',
    mh_surgical_none_label: 'Sin cirugías',
    mh_surgical_add_btn: 'Agregar cirugía',
    mh_surgical_none_cta: 'No me he sometido a cirugías en el pasado',
    mh_surgical_form_surgery_label: 'Cirugía',
    mh_surgical_form_surgery_required: 'Por favor, selecciona una opción',
    // Patient Portal - Emergency Contacts
    emergency_contacts_title: 'Contactos de emergencia',
    emergency_contacts_intro:
      'Por favor, agrega los datos de contacto de las personas a las que nos permites contactar en caso de una emergencia.',
    emergency_contacts_add_btn: 'Agregar contacto de emergencia',
    relationship: 'Parentesco',
    validation_select_option: 'Selecciona una opción',

    // Relationship types (from RelationshipType enum)
    relationship_type_emergency_contact: 'Contacto de emergencia',
    relationship_type_guardian: 'Tutor',
    relationship_type_next_of_kin: 'Familiar más cercano',
    relationship_type_caregiver: 'Cuidador',
    relationship_type_parent: 'Padre/Madre',
    relationship_type_child: 'Hijo/Hija',
    relationship_type_spouse: 'Esposo/Esposa',
    relationship_type_sibling: 'Hermano/Hermana',
    relationship_type_mother: 'Madre',
    relationship_type_father: 'Padre',
    relationship_type_son: 'Hijo',
    relationship_type_daughter: 'Hija',
    relationship_type_grandmother: 'Abuela',
    relationship_type_grandfather: 'Abuelo',
    relationship_type_granddaughter: 'Nieta',
    relationship_type_grandson: 'Nieto',
    relationship_type_aunt: 'Tía',
    relationship_type_uncle: 'Tío',
    relationship_type_niece: 'Sobrina',
    relationship_type_nephew: 'Sobrino',
    relationship_type_cousin: 'Primo/Prima',
    relationship_type_legal_guardian: 'Tutor legal',
    relationship_type_foster_parent: 'Padre/Madre de acogida',
    relationship_type_adoptive_parent: 'Padre/Madre adoptivo/a',
    relationship_type_step_parent: 'Padrastro/Madrastra',
    relationship_type_step_son: 'Hijo del cónyuge',
    relationship_type_step_daughter: 'Hija del cónyuge',
    relationship_type_foster_son: 'Hijo de acogida',
    relationship_type_foster_daughter: 'Hija de acogida',
    relationship_type_step_sibling: 'Hermanastro/a',
    relationship_type_in_law: 'Cuñado/Cuñada/Suegro/Suegra',
    relationship_type_domestic_partner: 'Pareja de hecho',
    relationship_type_lawyer: 'Abogado/a',
    relationship_type_doctor: 'Médico/a',
    relationship_type_therapist: 'Terapeuta',
    relationship_type_social_worker: 'Trabajador/a social',
    relationship_type_case_manager: 'Gestor/a de casos',
    relationship_type_nurse: 'Enfermero/a',
    relationship_type_neighbor: 'Vecino/a',
    relationship_type_coworker: 'Compañero/a de trabajo',
    relationship_type_roommate: 'Compañero/a de cuarto',
    relationship_type_mentor: 'Mentor/a',
    relationship_type_mentee: 'Aprendiz',
    relationship_type_religious_leader: 'Líder religioso',
    relationship_type_volunteer: 'Voluntario/a',
    relationship_type_colleague: 'Colega',
    relationship_type_supervisor: 'Supervisor/a',
    relationship_type_subordinate: 'Subordinado/a',
    relationship_type_godparent: 'Padrino/Madrina',
    relationship_type_godchild: 'Ahijado/Ahijada',
    relationship_type_ward: 'Pupilo',
    relationship_type_sponsor: 'Patrocinador/a',
    relationship_type_benefactor: 'Benefactor/a',
    relationship_type_friend: 'Amigo/a',
    relationship_type_acquaintance: 'Conocido/a',
    relationship_type_partner: 'Pareja',
    relationship_type_other: 'Otro',

    // Minor Guardian Relationship translations
    minor_guardian_relationship_mother: 'Madre',
    minor_guardian_relationship_father: 'Padre',
    minor_guardian_relationship_aunt: 'Tía',
    minor_guardian_relationship_uncle: 'Tío',
    minor_guardian_relationship_grandmother: 'Abuela',
    minor_guardian_relationship_grandfather: 'Abuelo',
    minor_guardian_relationship_son: 'Hijo',
    minor_guardian_relationship_daughter: 'Hija',
    minor_guardian_relationship_step_son: 'Hijo del cónyuge',
    minor_guardian_relationship_step_daughter: 'Hija del cónyuge',
    minor_guardian_relationship_step_mother: 'Madrastra',
    minor_guardian_relationship_step_father: 'Padrastro',
    minor_guardian_relationship_foster_son: 'Hijo de acogida',
    minor_guardian_relationship_foster_daughter: 'Hija de acogida',
    minor_guardian_relationship_foster_mother: 'Madre de acogida',
    minor_guardian_relationship_foster_father: 'Padre de acogida',
    minor_guardian_relationship_ward: 'Pupilo',
    minor_guardian_relationship_grandson: 'Nieto',
    minor_guardian_relationship_granddaughter: 'Nieta',
    minor_guardian_relationship_niece: 'Sobrina',
    minor_guardian_relationship_nephew: 'Sobrino',
    minor_guardian_relationship_cousin: 'Primo/a',
    minor_guardian_relationship_other: 'Otro',

    // Patient Portal - Pharmacy Step
    pharmacy_search_label: 'Buscar farmacia',
    pharmacy_search_placeholder: 'Buscar por nombre, dirección o código postal',

    // Stepper - Completion messages
    stepper_finish_title: '¡Todo listo!',
    stepper_finish_btn_home: 'Volver a la página principal',
    stepper_finish_desc:
      'Agradecemos tu tiempo y esfuerzo al compartir tu información. Esto nos ayuda a brindar una atención segura y personalizada y a priorizar tu salud.',
    stepper_close_btn: 'Cerrar',
    stepper_thankyou_title: '¡Gracias!',
    stepper_finish_description:
      'Tu información se ha enviado correctamente. Por favor, vuelve al chat con tu proveedor para continuar la conversación y recibir más indicaciones.',
    mh_surgical_form_other_label: 'Especificar otra cirugía',
    mh_surgical_form_other_required: 'Por favor, especifica la cirugía',
    mh_surgical_form_other_placeholder: 'Ingresa el nombre de la cirugía',

    // Medical History - PDF
    pdf_medical_history_title: 'HISTORIAL MÉDICO',
    pdf_label_gender: 'Género',
    pdf_label_dob: 'Fecha de nacimiento',
    pdf_label_height: 'Altura',
    pdf_label_weight: 'Peso',
    pdf_label_office: 'Teléfono',
    pdf_label_website: 'Sitio web',
    pdf_label_email: 'Email',
    pdf_past_sessions_title: 'SESIONES PASADAS',
    // Auth - Recover Password
    email_required: 'Por favor, ingresa tu correo electrónico',
    unknown_error_try_again: 'Error desconocido, por favor inténtalo más tarde.',

    // Auth - Send Code / Enter Code / Send Mail
    sendcode_title: 'Tu línea directa de atención',
    sendcode_description:
      'Ingresa tu número de teléfono móvil para recibir un código de verificación por SMS. Pueden aplicarse cargos del operador.',
    need_assistance: '¿Necesitas ayuda?',
    reach_out_at: 'Contáctanos en',
    read_prefix: 'Lee TapTelehealth',
    terms_and_conditions: 'Términos y Condiciones',
    enter_code_title: 'Ingresa tu código',
    enter_code_phone_sent: 'Hemos enviado un código a tu teléfono que termina en',
    enter_code_email_sent: 'Hemos enviado un código a tu correo electrónico',
    enter_code_enter_below: 'Ingrésalo abajo para verificar tu cuenta.',
    enter_code_send_new: 'Enviar nuevo código',
    enter_code_required: 'Por favor, ingresa el código de verificación',
    enter_code_must_be_6_digits: 'El código debe tener exactamente 6 dígitos',
    verify_cta: 'Verificar',
    send_code_cta: 'Enviar código',
    mobile_phone_number_label: 'Número de teléfono móvil',
    must_agree_to_continue: 'Debes aceptar para continuar',
    messaging_consent_text:
      'Consiento recibir mensajes SMS de Tap Telehealth sobre información general de salud y actualizaciones relacionadas con el servicio. Entiendo que pueden aplicarse tarifas de mensajes y datos y que la frecuencia de los mensajes varía. Puedo cancelar mi suscripción en cualquier momento a través del <portalLink>Portal del Paciente de Tap Telehealth</portalLink> o respondiendo STOP a cualquier mensaje. Obtén más información en nuestros <termsLink>Términos de Servicio</termsLink> y nuestra <privacyLink>Política de Privacidad</privacyLink>, o respondiendo HELP a cualquier mensaje.',
    email_consent_text:
      'Acepto recibir información y actualizaciones relacionadas con la salud por correo electrónico.',

    // Auth - Household
    household_where_located_title: '¿Dónde te encuentras?',
    household_where_located_desc:
      'Proporcionar tu dirección nos permite conectarte rápidamente con el proveedor de salud adecuado.',

    // Survey Module - Survey Steps
    survey_info_title: 'Ayúdanos a personalizar tu atención',
    survey_info_button: 'Comenzar',
    survey_info_description_part1:
      'Antes de completar tu receta, nos gustaría recopilar algunos datos de salud importantes. Este breve cuestionario',
    survey_info_description_part2: 'nos ayuda a garantizar tu seguridad y brindarte la mejor atención',
    survey_all_done_title: '¡Gracias!',
    survey_all_done_description:
      'Tu información se ha enviado correctamente. Por favor, vuelve al chat con tu clínico para continuar la conversación y recibir más indicaciones.',

    // Survey Module - Allergies Card
    survey_allergies_title: 'Alergias',
    survey_allergies_title_minor: 'Alergias de un menor',
    survey_allergies_question: '¿Tienes alguna alergia (medicamentos, alimentos, etc.)?',
    survey_allergies_question_minor: '¿Tu menor tiene alguna alergia (medicamentos, alimentos, etc.)?',
    survey_allergies_intro:
      'Compartir tu información de alergias garantiza recetas más seguras y nos ayuda a evitar reacciones adversas.',
    survey_allergies_intro_minor:
      'Compartir esta información de alergias garantiza recetas más seguras y nos ayuda a evitar reacciones adversas.',
    survey_allergies_no_cta: 'No, no tengo alergias',
    survey_allergies_no_cta_minor: 'No, el menor no tiene alergias',
    survey_allergies_yes_add: 'Sí, agregar alergia',
    survey_allergies_form_name_label: 'Nombre de la alergia',
    survey_allergies_form_name_required: 'Por favor, selecciona la alergia',
    survey_allergies_form_reaction_label: 'Reacción (Selecciona todas las que apliquen):',
    survey_allergies_form_other_placeholder: 'Por favor, especifica',
    survey_allergies_form_other_required: 'Por favor, especifica la reacción',
    survey_allergies_add_btn: 'Agregar alergia',
    survey_allergies_confirm_question: '¿Esta información de alergias es correcta y está completa?',
    survey_allergies_no_update: 'No, necesito agregar una alergia',
    survey_allergies_reaction_rash: 'Sarpullido/Urticaria',
    survey_allergies_reaction_swelling: 'Hinchazón',
    survey_allergies_reaction_breathing: 'Dificultad para respirar',
    survey_allergies_reaction_anaphylaxis: 'Anafilaxia',
    survey_allergies_reaction_gastro: 'Síntomas gastrointestinales',
    survey_allergies_reaction_itching: 'Comezón',
    survey_allergies_reaction_other: 'Otra',

    // Survey Module - Pharmacy Card
    survey_pharmacy_title: 'Seleccionar farmacia',
    survey_pharmacy_search_label: 'Buscar farmacia',
    survey_pharmacy_search_placeholder: 'Buscar por nombre, dirección o código postal',
    survey_pharmacy_add_btn: '+ Agregar',
    survey_pharmacy_confirm_question: '¿Esta farmacia es correcta?',
    survey_pharmacy_no_update: 'No, necesito actualizar mi farmacia',

    // Survey Module - Height Card
    survey_height_title: 'Altura',
    survey_height_title_minor: 'Altura del menor',
    survey_height_label: 'Tu altura',
    survey_height_label_minor: 'Altura del menor',
    survey_height_feet_required: 'Por favor, ingresa pies',
    survey_height_inches_required: 'Por favor, ingresa pulgadas',

    // Survey Module - Weight Card
    survey_weight_title: 'Peso',
    survey_weight_title_minor: 'Peso del menor',
    survey_weight_label: 'Tu peso (lb)',
    survey_weight_label_minor: 'Peso del menor (lb)',

    // Survey Module - First Question
    survey_q1_title: 'Cuéntanos sobre tus opciones de atención médica',
    survey_q1_question: 'Sin Tap Telehealth hoy, ¿cómo habrías obtenido atención?',
    survey_q1_instruction: 'Selecciona lo que realmente aplica a tu situación.',
    survey_q1_option1_title: 'Sin forma de obtener atención médica',
    survey_q1_option1_description:
      'Necesitaría llamar al 911 debido a falta de transporte, dificultad para conducir estando enfermo o problemas de movilidad.',
    survey_q1_option1_italic: '(Común para muchos pacientes)',
    survey_q1_option2_title: 'Sin opciones de atención inmediatas cercanas',
    survey_q1_option2_description:
      'La sala de emergencias sería mi única opción para atención el mismo día debido al horario, la ubicación o por necesitar atención fuera de horario.',
    survey_q1_option2_italic: '(Situación más común)',
    survey_q1_option3_title: 'Urgencias disponible',
    survey_q1_option3_description:
      'Tengo transporte y podría pagar un copago de $50-145, pero implicaría 1-2 horas de espera.',
    survey_q1_option4_title: 'Mi médico podría verme rápidamente',
    survey_q1_option4_description:
      'Tengo un médico de cabecera que ofrece citas el mismo día o al siguiente y los síntomas podrían esperar hasta entonces.',
    survey_q1_option5_title: 'Habría esperado a que pase',
    survey_q1_option5_description: 'Habría intentado autocuidado en casa sin buscar ayuda médica profesional.',

    // Survey Module - Second Question
    survey_q2_title: 'Tiempo ahorrado',
    survey_q2_info_line1: 'Las visitas médicas presenciales suelen implicar:',
    survey_q2_info_line2: '• 3-4 horas para una consulta (traslado + espera + cita)',
    survey_q2_info_line3: '• La mayoría toma un día completo libre del trabajo/escuela para las citas',
    survey_q2_info_line4: '• Sin tratamiento temprano, los síntomas suelen durar 2-3 días más',
    survey_q2_question: '¿Cuántos días de trabajo/escuela te ahorró Tap Telehealth?',
    survey_q2_option1: '3+ días (contando tiempo de cita y recuperación más rápida)',
    survey_q2_option2: '2 días (común cuando los síntomas se resuelven antes con tratamiento temprano)',
    survey_q2_option3: '1 día (típico para una sola visita presencial)',
    survey_q2_option4: 'Menos de 1 día',
    survey_q2_option5: 'No aplica (no trabajo/no estudio)',

    // Survey Module - Third Question
    survey_q3_title: 'Tiempo ahorrado',
    survey_q3_subtitle: 'Tu experiencia con nuestro servicio',
    survey_q3_info_line1: 'La telemedicina típicamente ahorra a los pacientes:',
    survey_q3_info_line2: '• 2-4 horas de traslado y espera',
    survey_q3_info_line3: '• $50-250 en costos',
    survey_q3_info_line4: '• La molestia de organizar transporte',
    survey_q3_slider1_label: '¿Qué tan probable es que recomiendes Tap Telehealth?',
    survey_q3_slider1_min: 'Nada probable',
    survey_q3_slider1_max: 'Extremadamente probable',
    survey_q3_slider2_label: '¿Qué tanto mejor fue Tap Telehealth que ir a una sala de emergencias o urgencias?',
    survey_q3_slider2_min: 'Nada mejor',
    survey_q3_slider2_max: 'Mucho mejor',
    survey_q3_slider3_label: '¿Qué tan fácil fue usar el servicio de Tap Telehealth?',
    survey_q3_slider3_min: 'Muy difícil',
    survey_q3_slider3_max: 'Muy fácil',
    survey_q3_submit_btn: 'Enviar',

    // Survey Module - Fourth Question
    survey_q4_title: 'Cobertura',
    survey_q4_info:
      'Tu costo es el mismo sin importar cómo estés cubierto: solo preguntamos para entender a quién está llegando TAP. Esto es opcional.',
    survey_q4_question: '¿Actualmente tienes seguro de salud o Medicaid?',
    survey_q4_option1: 'Seguro privado / del empleador',
    survey_q4_option2: 'Medicaid',
    survey_q4_option3: 'Medicare',
    survey_q4_option4: 'No tengo seguro en este momento',
    survey_q4_option5: 'Prefiero no decirlo',

    // Survey Module - Additional Feedback
    survey_feedback_title: 'Comentarios adicionales',
    survey_feedback_subtitle:
      'Comparte cualquier otra cosa sobre tu experiencia con Tap Telehealth. Tus comentarios nos ayudan a mejorar nuestro servicio.',
    survey_feedback_info:
      'Por favor, no incluyas información personal o médica en tus comentarios, como nombres, datos de contacto o cualquier otra información que pueda identificarte.',
    survey_feedback_placeholder: 'Tus comentarios',
    survey_feedback_consent:
      'Acepto que mis comentarios o reseña puedan ser compartidos públicamente por Tap Telehealth, como en nuestro sitio web o redes sociales, sin ninguna información personal o identificativa.',
    survey_feedback_submit_btn: 'Enviar',

    // Survey Module - Savings Card
    survey_savings_title: 'Aquí está tu visita, por números.',
    survey_savings_subtitle: 'Una estimación conservadora de lo que hoy te habría costado en otro lugar.',

    // Survey Module - Advocate
    survey_thank_you_title: 'Gracias - esto realmente ayuda',
    survey_thank_you_text:
      'Tus comentarios honestos son la forma en que TAP mejora para ti y tus vecinos. Los hemos pasado al equipo de atención.',
    survey_advocate_no_medical_care_title: 'Te saltaste la puerta más cara que existe.',
    survey_advocate_no_care_options_title:
      'Manejaste con un mensaje de texto lo que normalmente cuesta $1,500 y una tarde.',
    survey_advocate_urgent_care_title: 'Sin copago. Sin sala de espera. Sin tarde perdida.',
    survey_advocate_doctor_quick_title: 'Tienes un doctor al que puedes contactar. Muchos vecinos no.',
    survey_advocate_waited_out_title: 'No esperaste y viste. Eso importa más de lo que piensas.',
    survey_advocate_no_medical_care_text:
      'Un mensaje de texto en lugar de una ambulancia y una sala de urgencias: ese es el golpe de ~$2,000 que la mayoría de las familias nunca ven venir, y tú lo evitaste. Ahora ve y muestra al vecino que siente que no tiene otra opción dónde está la puerta. Eso es lo que te convierte en uno de los mejores defensores de {{city}}.',
    survey_advocate_no_medical_care_text_no_city:
      'Un mensaje de texto en lugar de una ambulancia y una sala de urgencias: ese es el golpe de ~$2,000 que la mayoría de las familias nunca ven venir, y tú lo evitaste. Ahora ve y muestra al vecino que siente que no tiene otra opción dónde está la puerta.',
    survey_advocate_no_care_options_text:
      'La mayoría de la gente no sabe que un mensaje de texto puede hacer eso, pero tú sí. Así que dile al vecino que habría ido a la sala de urgencias esta noche: un mensaje de dos minutos lo habría solucionado. Eso es lo que te convierte en uno de los mejores defensores de {{city}}.',
    survey_advocate_no_care_options_text_no_city:
      'La mayoría de la gente no sabe que un mensaje de texto puede hacer eso, pero tú sí. Así que dile al vecino que habría ido a la sala de urgencias esta noche: un mensaje de dos minutos lo habría solucionado.',
    survey_advocate_urgent_care_text:
      'Saltaste el copago de ~$115 y la hora en una silla de plástico por algo que un mensaje de texto resolvió. Multiplica eso en todo el vecindario y es dinero real que se queda en {{city}}. Cuéntale a un vecino: eso es lo que te convierte en uno de sus mejores defensores.',
    survey_advocate_urgent_care_text_no_city:
      'Saltaste el copago de ~$115 y la hora en una silla de plástico por algo que un mensaje de texto resolvió. Cuéntale a un vecino: eso es lo que te convierte en uno de sus mejores defensores.',
    survey_advocate_doctor_quick_text:
      'Los que no terminan en atención urgente o en la sala de urgencias por cosas que un mensaje de texto habría solucionado. Puedes darles lo que ya tienes: indícales al doctor que no sabían que tenían. Eso es lo que te convierte en uno de los mejores defensores de {{city}}.',
    survey_advocate_doctor_quick_text_no_city:
      'Los que no terminan en atención urgente o en la sala de urgencias por cosas que un mensaje de texto habría solucionado. Puedes darles lo que ya tienes: indícales al doctor que no sabían que tenían.',
    survey_advocate_waited_out_text:
      'Lo que ignoras el martes es el viaje a la sala de urgencias el sábado, y tú lo evitaste. Ahora ve y dile al vecino que todavía está resistiendo: un mensaje de dos minutos podría salvarles un fin de semana en la sala de espera. Eso es lo que te convierte en uno de los mejores defensores de {{city}}.',
    survey_advocate_waited_out_text_no_city:
      'Lo que ignoras el martes es el viaje a la sala de urgencias el sábado, y tú lo evitaste. Ahora ve y dile al vecino que todavía está resistiendo: un mensaje de dos minutos podría salvarles un fin de semana en la sala de espera.',
    survey_advocate_share_button: 'Comparte tu experiencia →',

    // Survey Module - Share
    survey_share_title: 'Comparte el amor (y los ahorros)!',
    survey_share_subtitle: 'Un toque - tu tarjeta y un pie de foto están listos para usar.',
    survey_share_caption_heading: 'Tu pie de foto',
    survey_share_no_medical_care_caption:
      'No podría haber llegado a un doctor hoy - así que le envié un mensaje de texto y obtuve lo que necesitaba en minutos. Eso es un viaje a la sala de urgencias/ambulancia de ~$2,000 que no tuve que hacer. Increíble que más personas no sepan que {{city}} tiene esto. 💙 #ADoctorIsJustATapAway',
    survey_share_no_medical_care_caption_no_city:
      'No podría haber llegado a un doctor hoy - así que le envié un mensaje de texto y obtuve lo que necesitaba en minutos. Eso es un viaje a la sala de urgencias/ambulancia de ~$2,000 que no tuve que hacer. 💙 #ADoctorIsJustATapAway',
    survey_share_no_care_options_caption:
      'Le escribí a un doctor de verdad en lugar de sentarme en la sala de emergencias esta noche: respuesta y receta en unos 15 minutos, sin una factura de $1,500. Si estas en {{city}}, tu también tienes esto. 💙 #ADoctorIsJustATapAway',
    survey_share_no_care_options_caption_no_city:
      'Le escribí a un doctor de verdad en lugar de sentarme en la sala de emergencias esta noche: respuesta y receta en unos 15 minutos, sin una factura de $1,500. 💙 #ADoctorIsJustATapAway',
    survey_share_urgent_care_caption:
      'Me salté el copago de urgencias y la sala de espera: le escribi a un doctor y termine en minutos. Parece poco, pero se acumula. Que bueno que {{city}} tiene esto. 💙 #ADoctorIsJustATapAway',
    survey_share_urgent_care_caption_no_city:
      'Me salté el copago de urgencias y la sala de espera: le escribi a un doctor y termine en minutos. Parece poco, pero se acumula. 💙 #ADoctorIsJustATapAway',
    survey_share_doctor_quick_caption:
      'Tengo un doctor al que puedo contactar, y ahora puedo hacerlo por mensaje en minutos, de día o de noche. Si no tienes un doctor al que puedas llegar, {{city}} te da uno. 💙 #ADoctorIsJustATapAway',
    survey_share_doctor_quick_caption_no_city:
      'Tengo un doctor al que puedo contactar, y ahora puedo hacerlo por mensaje en minutos, de día o de noche. 💙 #ADoctorIsJustATapAway',
    survey_share_waited_out_caption:
      'Normalmente lo habría aguantado, pero en su lugar le escribi a un doctor y lo traté a tiempo. Dos minutos le ganan a un fin de semana sintiéndome fatal. {{city}} tiene esto si tu tambien. 💙 #ADoctorIsJustATapAway',
    survey_share_waited_out_caption_no_city:
      'Normalmente lo habría aguantado, pero en su lugar le escribi a un doctor y lo traté a tiempo. Dos minutos le ganan a un fin de semana sintiéndome fatal. 💙 #ADoctorIsJustATapAway',
    survey_share_label: 'Compartir',
    survey_share_facebook: 'Facebook',
    survey_share_x: 'Publicar en X',
    survey_share_copy_caption: 'Copiar pie de foto',
    survey_share_save_card: 'Guardar imagen de la tarjeta',

    // Medical History Survey Module
    mhs_intro_title: 'Tu resumen de salud',
    mhs_intro_description:
      'Por favor responde algunas preguntas rápidas para que podamos entender mejor tu salud y personalizar tu atención.',
    mhs_medications_title: 'Medicamentos actuales',
    mhs_medications_subtitle:
      'Enumera todos los medicamentos que tomas actualmente, incluyendo recetas, medicamentos sin receta, vitaminas y suplementos',
    mhs_conditions_title: 'Condiciones de salud',
    mhs_conditions_subtitle: 'Selecciona todas las condiciones de salud que apliquen a tu caso.',
    mhs_add_health_condition: 'Agregar condición de salud',
    mhs_surgical_title: 'Historial quirúrgico',
    mhs_surgical_subtitle: 'Cuéntanos sobre cualquier cirugía o procedimiento que hayas tenido en el pasado.',
    mhs_add_surgery: 'Agregar cirugía',
    mhs_success_title: '¡Gracias!',
    mhs_success_description: 'Ahora puedes volver al chat para continuar con un proveedor.',

    // Medical History Survey - UI
    mhs_search_medication_placeholder: 'Buscar medicamento',
    mhs_search_condition_placeholder: 'Buscar condición',
    mhs_search_surgery_placeholder: 'Buscar procedimiento quirúrgico',
    mhs_most_common_medications: 'Medicamentos más comunes',
    mhs_most_common_conditions: 'Condiciones más comunes',
    mhs_most_common_surgeries: 'Cirugías más comunes',
    mhs_no_medications: 'No tomo ningún medicamento',
    mhs_other_medication_not_listed: 'Otro medicamento que no está en la lista',
    mhs_no_conditions: 'No tengo ninguna condición de salud',
    mhs_other_condition_not_listed: 'Otra condición que no está en la lista',
    mhs_no_surgeries: 'No he tenido ninguna cirugía',
    mhs_other_surgery_not_listed: 'Otra cirugía que no está en la lista',
    mhs_validation_select_option: 'Por favor selecciona al menos una opción',
    mhs_medication_type_label: 'Tipo:',
    mhs_medication_dose_label: 'Dosis/Concentración:',
    mhs_medication_frequency_label: '¿Con qué frecuencia?',
    mhs_frequency_once_daily: 'Una vez al día',
    mhs_frequency_twice_daily: 'Dos veces al día',
    mhs_frequency_three_times_daily: 'Tres veces al día',
    mhs_frequency_four_times_daily: 'Cuatro veces al día',
    mhs_frequency_as_needed: 'Según sea necesario',
    mhs_frequency_unknown: 'No lo sé',

    // Opt Out Module
    optout_title: 'Solicitud de exclusión de Tap Telehealth',
    optout_description:
      'Por favor, complete este formulario para que podamos reenviar su solicitud al Departamento de Facturación de Servicios Públicos de la Ciudad.',
    optout_account_number_label: 'Número de cuenta de servicios públicos',
    optout_submit_button: 'Enviar',
    optout_success_title: '¡Gracias!',
    optout_success_subtitle:
      'Gracias por enviar su solicitud. Reenviaremos su información al Departamento de Facturación de Servicios Públicos de la Ciudad.',
    optout_error_message: 'No podemos enviar su solicitud en este momento. Por favor, inténtelo de nuevo más tarde.',
    optout_account_number_required: 'Por favor, ingrese su número de cuenta de servicios públicos',

    // Opt In Module
    optin_title: 'Reincorporarse a {{programName}}',
    optin_description_opted_out_on: 'Su hogar se dio de baja de {{programName}} el {{optedOutDate}}.',
    optin_description_opted_out: 'Su hogar se ha dado de baja de {{programName}}.',
    optin_description_address: 'La dirección registrada es {{address}}.',
    optin_description_confirm: 'Si desea volver a participar, marque la casilla a continuación y envíe su solicitud.',
    optin_members_intro: 'Esto restaurará el acceso a:',
    optin_confirm_label: 'Confirmo que quiero reincorporarme',
    optin_link_expired_title: 'Este enlace ha caducado',
    optin_link_expired_subtitle: 'Envíenos un mensaje de nuevo para obtener uno nuevo.',
    optin_no_household_title: 'No se encontró un hogar',
    optin_no_household_subtitle: 'No pudimos encontrar un hogar asociado con su registro de paciente.',
    optin_submit_button: 'Enviar',
    optin_success_title: '¡Gracias!',
    optin_success_subtitle: 'Hemos recibido su solicitud.',
    optin_error_message: 'No podemos enviar su solicitud en este momento. Por favor, inténtelo de nuevo más tarde.',
    optin_already_active_title: 'No se requiere ninguna acción',
    optin_already_active_subtitle:
      'Su hogar ya está inscrito o ha solicitado recientemente una actualización de su participación.',

    // Demographics form token
    demographics_load_error_title: 'No se pudo cargar su formulario',
    demographics_link_expired_title: 'Este enlace ha caducado',
    demographics_link_expired_subtitle: 'Escriba a su proveedor para obtener uno nuevo.',
    demographics_load_error_subtitle: 'Vuelva a intentarlo en un momento.',
    demographics_wrong_patient:
      'Este formulario pertenece al expediente de otro paciente: comuníquese con su proveedor',
    demographics_minor_adding_for: 'Agregando un menor para {{name}}',
    demographics_minor_existing_children: 'Menores que ya figuran en su expediente',

    // Medical History
    mh_medications_no_update: 'No, necesito actualizar mis medicamentos',
    mh_conditions_no_update: 'No, necesito actualizar mis condiciones de salud',
    mh_surgical_no_update: 'No, necesito actualizar mi historial quirúrgico',
    mh_medications_confirm_question: '¿Es correcta y completa esta información sobre medicamentos?',
    mh_conditions_confirm_question: '¿Es correcta y completa esta información sobre condiciones de salud?',
    mh_surgical_confirm_question: '¿Es correcta y completa esta información sobre historial quirúrgico?',
    mh_conditions_none_label: 'No tengo ninguna condición de salud',
    mh_none_fallback_label: 'No se han seleccionado elementos',
    mh_allergies_skip: 'No tengo ninguna alergia',
    mh_minor_allergies_skip: 'El menor no tiene ninguna alergia',

    // Lab document
    lab_document_ready_title: 'Su documento de laboratorio está listo',
    lab_document_open: 'Abrir documento',
    lab_document_save: 'Guardar PDF',
    lab_document_expired_title: 'Este enlace ha caducado',
    lab_document_expired_subtitle: 'Envíe un mensaje a su proveedor para obtener uno nuevo.',
    lab_document_missing_title: 'Documento no encontrado',
    lab_document_missing_subtitle: 'Verifique el enlace en su mensaje o comuníquese con su proveedor.',
    lab_document_error_title: 'No se pudo cargar su documento',
    lab_document_error_subtitle: 'Por favor, inténtelo de nuevo en un momento.',

    // Lab visit booking
    lab_visit_ordered_by: 'Análisis solicitados por el Dr. {{name}}',
    lab_visit_ordered_by_care_team: 'Análisis solicitados por su equipo de atención',
    lab_visit_title_choose_location: 'Laboratorios cerca de usted',
    lab_visit_title_your_visit: 'Su visita al laboratorio',
    lab_visit_title_walk_in: 'Vaya sin cita - cualquier día',
    lab_visit_fasting_title: 'Esta visita requiere ayuno',
    lab_visit_requisition_link: '¿Necesita la orden en papel? Descargar PDF',
    lab_visit_retry: 'Intentar de nuevo',
    lab_visit_not_found_title: 'Enlace no encontrado',
    lab_visit_not_found_subtitle: 'Revise el enlace de su mensaje o comuníquese con su equipo de atención.',
    lab_visit_expired_title: 'Este enlace ha caducado',
    lab_visit_expired_subtitle: 'Escriba a su equipo de atención para obtener uno nuevo.',
    lab_visit_expired_sms: 'Escribir a mi equipo de atención',
    lab_visit_rate_limited_title: 'Un momento...',
    lab_visit_rate_limited_subtitle: 'Espere unos segundos e inténtelo de nuevo.',
    lab_visit_searching_near: 'Buscando cerca de',
    lab_visit_find_locations: 'Buscar centros',
    lab_visit_zip_hint:
      '¿Va a estar en otro lugar esta semana? Cambie el código postal - cerca del trabajo también sirve.',
    lab_visit_location_distance: '{{miles}} mi',
    lab_visit_location_site_code: 'Centro {{code}}',
    lab_visit_book_a_time: 'Reservar hora',
    lab_visit_just_walk_in: 'Ir sin cita',
    lab_visit_show_more: 'Ver más ({{count}} más cerca)',
    lab_visit_locations_empty: 'No se encontraron centros Quest para ese código postal. Pruebe con uno cercano.',
    lab_visit_locations_error: 'No pudimos cargar los centros. Inténtelo de nuevo.',
    lab_visit_slots_title: '¿Cuándo le conviene?',
    lab_visit_all_locations: 'Todos los centros',
    lab_visit_slot_first: 'Primera',
    lab_visit_slots_empty: 'No hay horas disponibles en este centro. Pruebe con otro.',
    lab_visit_slots_error: 'No pudimos cargar las horas de este centro. Inténtelo de nuevo.',
    lab_visit_slot_taken: 'Esa hora se acaba de ocupar - estas son las opciones actuales.',
    lab_visit_book_error: 'No pudimos reservar esa hora. Inténtelo de nuevo.',
    lab_visit_booked_eyebrow: 'Todo listo',
    lab_visit_booked_when: '{{date}} a las {{time}}',
    lab_visit_confirmation_code: 'Código de confirmación {{code}}',
    lab_visit_confirmation_hint: 'En recepción pueden localizarle con este código.',
    lab_visit_bring_photo_id: 'Una identificación con foto - la licencia de conducir sirve',
    lab_visit_bring_empty_stomach: 'El estómago vacío',
    lab_visit_bring_nothing_else: 'Eso es todo - sin papeleo, su orden ya está en su sistema',
    lab_visit_show_check_in_card: 'Ver mi tarjeta de registro',
    lab_visit_change_time: 'Cambiar la hora',
    lab_visit_keep_current_time: 'Mantener la hora actual',
    lab_visit_cancel_visit: 'Cancelar la visita',
    lab_visit_cancel_confirm_title: '¿Cancelar esta visita?',
    lab_visit_cancel_confirm_description:
      '¿Seguro que quiere cancelar la hora reservada? Una vez confirmado, podrá reservar otra hora',
    lab_visit_cancel_confirm_keep: 'Mantenerla',
    lab_visit_cancel_error: 'No pudimos cancelar su visita. Inténtelo de nuevo.',
    lab_visit_walk_in_intro:
      'Su orden ya está en el sistema de Quest. Vaya cuando el centro esté abierto - no necesita cita.',
    lab_visit_walk_in_pick_label: 'Su elección',
    lab_visit_walk_in_any_location: 'Cualquier centro Quest',
    lab_visit_walk_in_bring_label: 'Lleve esto',
    lab_visit_bring_photo_id_label: 'Una identificación con foto',
    lab_visit_bring_photo_id_detail: 'Es lo único que Quest necesita',
    lab_visit_bring_stomach_water: 'El agua está bien; no desayune esa mañana',
    lab_visit_bring_stomach_nothing: 'No coma ni beba nada antes de su visita',
    lab_visit_book_a_time_instead: 'Reservar una hora en su lugar',
    lab_visit_walk_in_error: 'No pudimos guardar su visita sin cita. Inténtelo de nuevo.',
    lab_visit_walk_in_switch_error: 'No pudimos cambiar a reservar hora. Inténtelo de nuevo.',
    lab_visit_check_in_title: 'Muestre esto en recepción',
    lab_visit_check_in_patient: 'Paciente',
    lab_visit_check_in_dob: 'Fecha de nacimiento',
    lab_visit_check_in_requisition: 'Orden',
    lab_visit_check_in_confirmation: 'Código de confirmación',
    lab_visit_check_in_you_owe: 'Usted debe',
    lab_visit_check_in_error: 'No pudimos cargar su tarjeta de registro. Inténtelo de nuevo.',
    lab_visit_degraded_eyebrow: 'La reserva en línea no funciona ahora',
    lab_visit_degraded_intro:
      'El sistema de citas de Quest no responde. Normalmente se restablece en menos de una hora.',
    lab_visit_degraded_good_news:
      '<strong>Buenas noticias:</strong> en realidad no necesita cita. Su orden ya está en su sistema - puede ir sin cita en cualquier horario de apertura.',
    lab_visit_degraded_find_quest: 'Buscar un centro Quest',
    lab_visit_degraded_bring_slip: 'Lleve su orden de laboratorio.',
    lab_visit_walk_in_instead: 'Ir sin cita en su lugar',
    lab_visit_try_booking_again: 'Intentar reservar de nuevo',
    lab_visit_upstream_down_notice:
      'El sistema de citas de Quest no responde, así que esta visita no se puede cambiar ni cancelar ahora. Inténtelo de nuevo en unos minutos.',
    lab_visit_error_title: 'No pudimos cargar su visita al laboratorio',
    lab_visit_error_subtitle: 'Por favor, inténtelo de nuevo en un momento.',

    // Visits & notes
    menu_visits_notes: 'Visitas y notas',
    visits_notes_title: 'Visitas y notas',
    visits_notes_load_more: 'Cargar más',
    visits_notes_practitioner: 'Dr. {{name}}',
    visits_notes_medications_prescribed_one: '{{count}} medicamento recetado',
    visits_notes_medications_prescribed_other: '{{count}} medicamentos recetados',
    visits_notes_lab_order: 'Análisis de sangre',
    visits_notes_filter_all: 'Todos',
    visits_notes_filter_visits: 'Visitas',
    visits_notes_filter_notes: 'Justificantes escolares y laborales',
    visits_notes_filter_tests: 'Pruebas',
    visits_notes_empty_notes: 'No hay justificantes escolares ni laborales que mostrar de las visitas cargadas',
    visits_notes_empty_tests: 'No hay pruebas que mostrar de las visitas cargadas',
    visits_notes_error_title: 'No pudimos cargar sus visitas',
    visits_notes_error_subtitle: 'Por favor, inténtelo de nuevo en un momento.',

    // Lab results
    menu_savings: 'Ahorros',
    savings_title: 'Tus ahorros',
    savings_subtitle: 'Un poco más de margen para lo que importa.',
    savings_scope_me: 'Yo',
    savings_scope_household: 'Hogar',
    savings_period_option_all_time: 'Todo el tiempo',
    savings_period_option_this_month: 'Este mes',
    savings_period_option_last_month: 'Mes pasado',
    savings_period_option_this_year: 'Este año',
    savings_period_option_last_year: 'Año pasado',
    savings_period_option_custom: 'Rango personalizado',
    savings_period_all_time: 'en total',
    savings_period_this_month: 'este mes',
    savings_period_last_month: 'el mes pasado',
    savings_period_this_year: 'este año',
    savings_period_last_year: 'el año pasado',
    savings_period_custom: '{{from}} – {{to}}',
    savings_total_eyebrow: 'Tu valor diario',
    savings_total_period: 'Ahorro estimado {{period}}',
    savings_total_period_empty: 'Ahorros registrados {{period}}',
    savings_empty_title: 'Aún no hay ahorros registrados',
    savings_empty_subtitle:
      'Cuando uses Tap, los ahorros en tu atención médica, recetas, análisis de laboratorio y control de peso aparecerán aquí automáticamente.',
    savings_category_prescriptions: 'Ahorro en recetas',
    savings_category_care: 'Ahorro en atención',
    savings_category_labs: 'Ahorro en análisis de laboratorio',
    savings_category_weight_program: 'Ahorro en control de peso',
    savings_category_workdays: 'Días de trabajo recuperados',
    savings_count_prescriptions: '{{count}} medicamento(s)',
    savings_count_care: '{{count}} visita(s)',
    savings_count_labs: '{{count}} análisis',
    savings_count_weight_program: '{{count}} mes(es) de cuotas del programa',
    savings_count_workdays_one: '{{days}} día',
    savings_count_workdays_other: '{{days}} días',
    savings_error_savings_disabled_title: 'Los ahorros no están disponibles en este momento',
    savings_error_savings_disabled_subtitle: 'Vuelve a consultarlo más tarde.',
    savings_error_not_found_title: 'No encontramos ahorros para este paciente',
    savings_error_not_found_subtitle: 'Prueba a seleccionar otro paciente.',
    savings_error_invalid_period_title: 'Ese rango de fechas no es válido',
    savings_error_invalid_period_subtitle: 'Elige una fecha de inicio igual o anterior a la fecha de fin.',
    savings_error_unknown_title: 'No pudimos cargar tus ahorros',
    savings_error_unknown_subtitle: 'Inténtalo de nuevo más tarde.',
    savings_drawer_close: 'Cerrar',
    savings_drawer_total_prescriptions: 'Total ahorrado en {{count}} medicamento(s)',
    savings_drawer_total_care: 'Total ahorrado en {{count}} visita(s)',
    savings_drawer_total_labs: 'Total ahorrado en {{count}} análisis',
    savings_drawer_total_weight_program: 'Total ahorrado en {{count}} mes(es) del programa de peso',
    savings_drawer_total_workdays_one: 'Total ahorrado en {{days}} día de trabajo recuperado',
    savings_drawer_total_workdays_other: 'Total ahorrado en {{days}} días de trabajo recuperados',
    savings_drawer_retail_price: 'Precio de venta',
    savings_drawer_you_paid: 'Pagaste',
    savings_drawer_estimated_expenses: 'Gastos personales estimados',
    savings_breakdown_title: 'Desglose de ahorros',
    savings_breakdown_empty: 'No hay ahorros registrados en este periodo.',
    savings_column_date: 'Fecha',
    savings_column_patient: 'Paciente',
    savings_column_medication: 'Medicamento',
    savings_column_retail_estimate: 'Precio de venta estimado',
    savings_column_coupon_price: 'Precio con cupón',
    savings_column_insurance_price: 'Precio estimado con seguro',
    savings_column_price_used: 'Precio usado',
    savings_column_savings: 'Ahorro',
    savings_column_care_option: 'Otra opción de atención',
    savings_column_estimated_expenses: 'Gastos personales estimados',
    savings_column_lab_test: 'Análisis',
    savings_column_program: 'Programa',
    savings_column_workdays: 'Días de trabajo recuperados',
    savings_column_workday_value: 'Valor estimado por día de trabajo',
    savings_care_option_no_medical_care: '911, ambulancia y sala de emergencias',
    savings_care_option_no_care_options: 'Visita a la sala de emergencias',
    savings_care_option_urgent_care: 'Visita a atención de urgencias',
    savings_care_option_doctor_quick: 'Visita de atención primaria',
    savings_care_option_waited_out: 'Esperé a que pasara',
    savings_workdays_value_one: '{{days}} día de trabajo',
    savings_workdays_value_other: '{{days}} días de trabajo',
    savings_explainer_title: 'Cómo estimamos tus ahorros',
    savings_explainer_intro:
      'La atención médica, las recetas y el tiempo fuera del trabajo suman. Así estimamos el valor que obtienes de Tap, a partir de tus registros de atención, tus respuestas a encuestas y comparaciones de precios.',
    savings_explainer_prescriptions_title: 'Ahorro en recetas',
    savings_explainer_prescriptions_p1:
      'Comparamos el precio de venta estimado de tu medicamento con el precio comparable más bajo disponible con cupón o con seguro. El mayor ahorro potencial se suma a tu total.',
    savings_explainer_prescriptions_p2:
      'El precio final en la farmacia puede ser distinto. Saber que recibiste tu medicamento no nos dice cuánto pagaste, así que esto sigue siendo una estimación.',
    savings_explainer_prescriptions_p3:
      'Basado en los precios de venta y con cupón de los informes de cupones de DoseSpot, y en las estimaciones de seguro de la información de beneficios de recetas en tiempo real de DoseSpot.',
    savings_explainer_care_title: 'Ahorro en atención',
    savings_explainer_care_p1:
      'En tu encuesta nos dices adónde habrías ido si Tap no hubiera estado disponible. Usamos un costo típico estimado para esa opción de atención para calcular lo que podrías haber gastado.',
    savings_explainer_care_p2:
      'Si elegiste “esperar a que pase”, esa visita no suma nada a tus ahorros. Si no respondiste, dejamos esa visita fuera de este cálculo.',
    savings_explainer_care_p3:
      'Basado en tu respuesta a la encuesta y en las estimaciones fijas de Tap para cada opción de atención.',
    savings_explainer_labs_title: 'Ahorro en análisis de laboratorio',
    savings_explainer_labs_p1:
      'Por cada orden de laboratorio gratuita, sumamos un ahorro estimado fijo cuando todos tus resultados están disponibles.',
    savings_explainer_labs_p2:
      'Cada orden cuenta una vez, tanto si incluye un análisis como varios análisis y paneles.',
    savings_explainer_labs_p3:
      'Basado en las órdenes de laboratorio completadas en tus registros y en la estimación fija de Tap por orden.',
    savings_explainer_weight_program_title: 'Ahorro en control de peso',
    savings_explainer_weight_program_p1:
      'Sumamos un ahorro estimado fijo por cada mes natural en que participas en el programa de control de peso después de iniciar el tratamiento.',
    savings_explainer_weight_program_p2:
      'Un mes parcial cuenta como un mes completo. Cada mes se cuenta solo una vez, aunque los periodos de participación se superpongan. El ahorro en medicamentos se incluye en el ahorro en recetas.',
    savings_explainer_weight_program_p3:
      'Basado en las fechas de tu tratamiento y en una cuota mensual de programa comparable.',
    savings_explainer_workdays_title: 'Días de trabajo recuperados',
    savings_explainer_workdays_p1:
      'Tu encuesta nos dice cuánto tiempo de trabajo recuperaste. Contamos tu respuesta como medio día, 1, 2 o 3 días y la multiplicamos por un valor fijo por día de trabajo.',
    savings_explainer_workdays_p2:
      'Si recuperaste tiempo cuidando a tu hijo o hija, esos días se te acreditan a ti como padre o madre. En una visita compartida, usamos el mayor número de días indicado y lo contamos una vez.',
    savings_explainer_workdays_p3:
      'Es una estimación del valor de tu tiempo, no ingresos confirmados ni dinero recibido.',
    savings_explainer_workdays_p4:
      'Basado en tus respuestas a la encuesta. El valor diario procede de la mediana de ingresos semanales de la Oficina de Estadísticas Laborales de EE. UU., dividida entre cinco días laborables.',
    menu_lab_results: 'Resultados de análisis',
    lab_results_title: 'Resultados de análisis',
    lab_results_subtitle:
      'Todas las órdenes que usted o su médico solicitaron, las más recientes primero. Abra una para ver sus pruebas.',
    lab_results_order_number: 'Orden n.º {{number}}',
    lab_results_kind_panel: 'Panel',
    lab_results_kind_individual_tests: 'Pruebas individuales',
    lab_results_kind_mixed: 'Panel + pruebas',
    lab_results_ordered_by: 'Solicitado por el Dr. {{name}}',
    lab_results_ordered_by_you: 'Solicitado por usted',
    lab_results_ordered_by_care_team: 'Solicitado por su equipo médico',
    lab_results_released_on: 'Publicado el {{date}}',
    lab_results_status_awaiting_visit: 'Pendiente de visita',
    lab_results_status_scheduled: 'Visita reservada',
    lab_results_status_processing: 'Esperando resultados',
    lab_results_status_results_ready: 'Resultados listos',
    lab_results_status_rejected: 'No se pudo procesar',
    lab_results_status_cancelled: 'Cancelada',
    lab_results_status_expired: 'Caducada',
    lab_results_status_failed: 'No se pudo completar',
    lab_results_badge_needs_attention: '{{count}} requiere atención',
    lab_results_badge_worth_a_look: '{{count}} para revisar',
    lab_results_badge_in_range: 'En rango',
    lab_results_empty:
      'Todavía no hay resultados de análisis. Cuando su médico solicite pruebas de laboratorio, aparecerán aquí.',
    lab_results_error_title: 'No pudimos cargar sus resultados de análisis',
    lab_results_error_subtitle: 'Por favor, inténtelo de nuevo en un momento.',

    // Lab results - order details
    lab_results_order_not_found_title: 'No pudimos encontrar esta orden',
    lab_results_order_not_found_subtitle: 'Puede pertenecer a otro paciente o los resultados aún no se han publicado.',
    lab_results_biomarker_count_one: '{{count}} biomarcador',
    lab_results_biomarker_count_other: '{{count}} biomarcadores',
    lab_results_test_count_one: '{{count}} prueba',
    lab_results_test_count_other: '{{count}} pruebas',
    lab_results_group_in_range: 'En rango',
    lab_results_group_worth_a_look: 'Para revisar',
    lab_results_group_other: 'Otros',
    lab_results_group_needs_attention: 'Requiere atención',
    lab_results_test_status_pending: 'En espera',
    lab_results_test_status_final: 'Resultados recibidos',
    lab_results_test_status_corrected: 'Corregida',
    lab_results_test_status_not_performed: 'No realizada',
    lab_results_update_pending:
      'El laboratorio corrigió uno de estos resultados y su médico está revisando el cambio. Lo que ve aquí puede actualizarse.',
    lab_results_report_download: 'Descargar (PDF)',
    lab_results_report_filename: 'lab-report-{{number}}.pdf',
    lab_results_report_error: 'No pudimos descargar su informe. Por favor, inténtelo de nuevo.',
    lab_results_note_title: 'Nota clínica',
    lab_results_note_author: 'Dr. {{name}}',
    lab_results_note_empty: 'Sin nota. Su médico revisó estos resultados y los publicó sin comentarios.',
    lab_results_chip_all: 'Todos ({{count}})',
    lab_results_filter_empty: 'Ningún resultado coincide con el filtro seleccionado.',
    lab_results_attention_eyebrow: 'Requiere atención ahora',
    lab_results_attention_title_single: 'Un resultado requiere atención inmediata',
    lab_results_attention_title_multiple: '{{count}} resultados requieren atención inmediata',
    lab_results_attention_reference: '(referencia del laboratorio {{reference}})',
    lab_results_attention_eyebrow_soon: 'Contacte pronto a un médico',
    lab_results_attention_title_single_soon: 'Un resultado requiere atención pronto',
    lab_results_attention_title_multiple_soon: '{{count}} resultados requieren atención pronto',
    lab_results_attention_no_guide:
      'El laboratorio marcó este resultado como crítico. Su médico se pondrá en contacto con usted.',
    lab_safety_net_emergency: 'Llame al 911 o acuda a urgencias si',
    lab_safety_net_same_day: 'Consulte hoy mismo a un médico si',
    lab_results_text_doctor: 'Enviar mensaje a un médico de Tap',
    lab_results_attention_hours:
      'Mensajería de Tap de 7 a.m. a 10 p.m. La mensajería no sustituye la atención inmediata.',
    lab_results_ask_doctor_note: '¿Preguntas sobre esta orden? Su médico ve este resultado junto a su mensaje.',
    lab_results_ask_doctor_cta: 'Preguntar a un médico de Tap',
    lab_results_state_waiting_title: 'Esperando resultados',
    lab_results_state_waiting_body:
      'Su muestra aún no ha llegado al laboratorio. La mayoría de los resultados llegan de 2 a 3 días después de su visita; le enviaremos un mensaje cuando estén listos.',
    lab_results_state_processing_title: 'Esperando resultados',
    lab_results_state_processing_body:
      'Su muestra está en el laboratorio. La mayoría de los resultados llegan de 2 a 3 días después de su visita; le enviaremos un mensaje cuando estén listos.',
    lab_results_state_partial_title: 'Algunos resultados están en camino',
    lab_results_state_partial_body:
      'Algunos de sus resultados ya se han recibido y el resto sigue en el laboratorio. Le enviaremos un mensaje cuando estén todos listos.',
    lab_results_state_rejected_title: 'Esta orden no se pudo procesar',
    lab_results_state_rejected_body:
      'El laboratorio no pudo aceptar esta orden. Su médico se pondrá en contacto con usted.',
    lab_results_state_cancelled_title: 'Esta orden fue cancelada',
    lab_results_state_cancelled_body: 'Esta orden no generará ningún resultado.',
    lab_results_state_expired_title: 'Esta orden caducó',
    lab_results_state_expired_body:
      'No se recogió ninguna muestra a tiempo. Su médico puede solicitar las pruebas de nuevo.',
    lab_results_state_failed_title: 'Esta orden no se pudo completar',
    lab_results_state_failed_body:
      'Esta orden no generará ningún resultado. Su médico se pondrá en contacto con usted.',

    // Lab results - biomarker details
    lab_marker_not_found_title: 'No pudimos encontrar este resultado',
    lab_marker_not_found_subtitle: 'Puede pertenecer a otro paciente o aún no se ha publicado.',
    lab_marker_result: 'Su resultado',
    lab_marker_result_on: 'Su resultado · {{date}}',
    lab_marker_reference_caption:
      'Referencia del laboratorio {{reference}}. El rango proviene de este informe. No es lo mismo que un umbral urgente o crítico.',
    lab_marker_reference_plain: 'Referencia del laboratorio {{reference}}',
    lab_marker_meaning_title: 'Qué significa su resultado',
    lab_marker_next_step_title: '¿Qué debo hacer ahora?',
    lab_marker_why_this_matters: 'Por qué es importante',
    lab_marker_ask_doctor_note: '¿Preguntas sobre este resultado? Su médico ve este resultado junto a su mensaje.',
    lab_marker_content_pending: 'Los médicos de Tap están revisando la explicación de este resultado.',
    lab_marker_action_eyebrow: 'Actúe ahora',
    lab_marker_variants_title: '¿Algo de esto se aplica a usted?',
    lab_marker_variants_subtitle:
      'Elija una opción y la explicación de abajo se reescribirá para esa situación. Su resultado no cambia.',
    lab_marker_variants_adjusted: 'Explicación adaptada a: {{label}}',
    lab_marker_variant_female_pregnant: 'Estoy embarazada',
    lab_marker_variant_postmenopausal: 'Después de la menopausia',

    // Lab results - order history
    lab_results_history_title: 'Historial de la orden',
    lab_results_history_progress: '{{done}} de {{total}} pasos',
    lab_results_history_ordered: 'Orden solicitada',
    lab_results_history_ordered_by: 'Solicitado por el Dr. {{name}}',
    lab_results_history_ordered_by_you: 'Solicitado por usted',
    lab_results_history_ordered_by_care_team: 'Solicitado por su equipo médico',
    lab_results_history_ordered_detail_add_ons_one: '{{panels}} + {{count}} prueba adicional',
    lab_results_history_ordered_detail_add_ons_other: '{{panels}} + {{count}} pruebas adicionales',
    lab_results_history_sent_to_lab: 'Enviado a Quest Diagnostics',
    lab_results_history_sent_detail: 'Orden de laboratorio lista, no necesita ayuno',
    lab_results_history_sent_detail_fasting: 'Orden de laboratorio lista, se requiere ayuno',
    lab_results_history_visit_scheduled: 'Visita reservada',
    lab_results_history_visit_scheduled_next: 'Reservar una visita',
    lab_results_history_visit_detail_next: 'Elija un centro Quest y una hora, o vaya sin cita cualquier mañana',
    lab_results_history_sample_collected: 'Muestra recogida',
    lab_results_history_collected_walk_in: 'Fue sin cita a {{location}}',
    lab_results_history_collected_at: 'Recogida en {{location}}',
    lab_results_history_results_partial: 'Algunos resultados recibidos',
    lab_results_history_results_partial_detail: '{{resulted}} de {{total}} pruebas con resultado',
    lab_results_history_results_final: 'Todos los resultados recibidos',
    lab_results_history_results_final_next: 'Resultados',
    lab_results_history_results_final_detail: '{{tests}}, {{biomarkers}}',
    lab_results_history_results_final_detail_next:
      'Normalmente de 2 a 3 días después de su visita. Le enviaremos un mensaje cuando estén listos',
    lab_results_history_provider_review: 'Revisado por su médico',
    lab_results_history_reviewed_by: 'Revisado por el Dr. {{name}}',
    lab_results_history_provider_review_next: 'Revisión del médico',
    lab_results_history_provider_review_detail: 'No se requiere ninguna acción',
    lab_results_history_results_released: 'Publicado para usted',
    lab_results_history_results_released_next: 'Resultados publicados',
    lab_results_history_results_released_detail: 'Mensaje de texto enviado',

    // Free labs signup
    free_labs_eyebrow: 'Análisis gratuitos · Pagados por Tap · $0 para usted',
    free_labs_community: 'Comunidad: {{name}}',
    free_labs_community_batavia: 'Batavia, IL',
    free_labs_community_aurora: 'Aurora, IL',
    free_labs_community_rolling_meadows: 'Rolling Meadows, IL',
    free_labs_title_phone: 'Análisis de laboratorio gratuitos para residentes',
    free_labs_title_code: 'Ingrese el código que le enviamos por mensaje',
    free_labs_title_picker: '¿Quién hace el pedido hoy?',
    free_labs_title_form_new: 'Cuéntenos sobre usted',
    free_labs_title_form_returning: 'Bienvenido de nuevo, {{name}}',
    free_labs_session_expired: 'Su sesión expiró. Verifique su número de celular de nuevo para continuar.',
    free_labs_unavailable_title: 'Los análisis gratuitos no están disponibles en este momento',
    free_labs_unavailable_subtitle: 'Inténtelo de nuevo más tarde.',
    free_labs_error_generic: 'Algo salió mal. Inténtelo de nuevo.',
    free_labs_error_rate_limited: 'Demasiados intentos. Espere unos minutos e inténtelo de nuevo.',
    free_labs_error_send_failed: 'No pudimos enviar el código. Inténtelo de nuevo.',
    free_labs_phone_intro:
      'Está a punto de pedir un panel de análisis de sangre gratuito. El laboratorio requiere un número de celular verificado antes de que podamos hacer el pedido. Le enviaremos un código de 6 dígitos por mensaje de texto.',
    free_labs_phone_note: 'Un panel por persona. Su seguro no afecta la elegibilidad.',
    free_labs_phone_label: 'Número de celular',
    free_labs_phone_required: 'Ingrese su número de celular',
    free_labs_phone_invalid: 'Ingrese un número de celular válido de EE. UU.',
    free_labs_phone_cta: 'Enviarme un código',
    free_labs_phone_footer:
      'Pueden aplicarse tarifas de mensajes. A este número se enviarán su enlace de reserva y sus resultados.',
    free_labs_code_sent_to: 'Enviado a <strong>{{phone}}</strong>.',
    free_labs_code_change_number: 'Cambiar número',
    free_labs_code_cta: 'Verificar',
    free_labs_code_resend_prompt: '¿No lo recibió?',
    free_labs_code_resend: 'Reenviar código',
    free_labs_code_resent: 'Le enviamos un código nuevo.',
    free_labs_code_invalid: 'Ese código no es correcto. Revise el mensaje e inténtelo de nuevo.',
    free_labs_code_expired: 'Ese código expiró. Solicite uno nuevo.',
    free_labs_picker_intro:
      'Más de un adulto de su hogar usa este número. Elíjase a sí mismo para que podamos completar sus datos.',
    free_labs_picker_born: 'Nacido en {{year}}',
    free_labs_picker_unnamed: 'Miembro del hogar',
    free_labs_picker_order_placed: 'Pedido realizado',
    free_labs_picker_footnote:
      '¿No está en la lista? Un número conocido solo puede inscribir a los adultos ya registrados en él. Use su propio número de celular.',
    free_labs_picker_cta: 'Continuar',
    free_labs_picker_not_on_phone:
      'No pudimos cargar los datos de esa persona. Elija de nuevo o use su propio número de celular.',
    free_labs_last_request_title: 'Su solicitud del {{date}} no se completó',
    free_labs_last_request_outside_city:
      'La dirección estaba fuera de los límites de la ciudad del programa. Si se mudó o la dirección era incorrecta, actualícela abajo y envíe de nuevo.',
    free_labs_last_request_quota_full:
      'En ese momento ya se habían agotado los paneles gratuitos de esa comunidad. Puede enviar de nuevo abajo.',
    free_labs_last_request_duplicate:
      'Ya se pidió un panel gratuito para esta persona. Revise sus mensajes de texto para encontrar su enlace de reserva o sus resultados.',
    free_labs_last_request_address_unresolved:
      'No pudimos ubicar la dirección en el mapa. Elíjala de las sugerencias abajo y envíe de nuevo.',
    free_labs_last_request_order_failed:
      'El laboratorio no aceptó el pedido. Nuestro equipo fue notificado; puede enviar de nuevo abajo.',
    free_labs_last_order_title: 'Su pedido del {{date}} ya no está activo',
    free_labs_last_order_expired:
      'La orden de laboratorio expiró antes de tomar la muestra. Revise sus datos y envíe de nuevo abajo.',
    free_labs_last_order_cancelled: 'El pedido fue cancelado. Revise sus datos y envíe de nuevo abajo.',
    free_labs_last_order_rejected: 'El laboratorio no aceptó el pedido. Revise sus datos y envíe de nuevo abajo.',
    free_labs_last_order_failed: 'El laboratorio no aceptó el pedido. Revise sus datos y envíe de nuevo abajo.',
    free_labs_need_email_title: 'Necesitamos su correo electrónico',
    free_labs_need_email_body:
      'El laboratorio envía las instrucciones para la toma de muestra por correo electrónico. Aún no tenemos uno válido registrado.',
    free_labs_dob_hint: 'Debe tener 18 años o más.',
    free_labs_sex: 'Sexo',
    free_labs_sex_hint: 'Lo requiere el laboratorio para los rangos de referencia.',
    free_labs_email_required: 'El correo electrónico es obligatorio',
    free_labs_email_taken: 'Este correo electrónico pertenece a otro paciente. Use uno diferente.',
    free_labs_phone_taken: 'Este número de teléfono pertenece a otro paciente. Por favor, contáctenos.',
    free_labs_phone_verified: 'Verificado',
    free_labs_address: 'Dirección de residencia',
    free_labs_address_required: 'Elija su dirección de las sugerencias',
    free_labs_address_change: 'Cambiar',
    free_labs_consents_legend: 'Por favor confirme',
    free_labs_consent_required: 'Marque esta casilla para continuar',
    free_labs_consent_attestation: 'Tengo 18 años o más y vivo en la dirección indicada arriba.',
    free_labs_consent_sms:
      'Tap puede enviarme mensajes de texto sobre mi pedido y mis resultados de laboratorio. Pueden aplicarse tarifas de mensajes. Responda STOP en cualquier momento.',
    free_labs_consent_hipaa:
      'Acepto el <telehealth>consentimiento de telesalud</telehealth>, los <terms>términos de uso</terms> y la <privacy>política de privacidad</privacy>.',
    free_labs_form_not_on_phone: 'Esta persona no está registrada en su número de celular.',
    free_labs_submit_cta: 'Hacer mi pedido gratuito',
    free_labs_ordered_title: 'Su pedido de análisis gratuito está realizado',
    free_labs_ordered_subtitle:
      'Los resultados llegan por mensaje de texto, o un proveedor de Tap se comunicará con usted para revisarlos. También enviaremos el enlace de reserva a <strong>{{phone}}</strong>.',
    free_labs_ordered_waiting_title: 'Esperando que el laboratorio confirme su pedido…',
    free_labs_ordered_waiting_body:
      'Esto suele tomar un momento. También puede cerrar esta página: el enlace de reserva llegará por mensaje de texto.',
    free_labs_ordered_texted_title: 'Le enviaremos el enlace de reserva por mensaje',
    free_labs_ordered_texted_body:
      'El laboratorio aún está confirmando su pedido. En cuanto lo haga, el enlace para reservar su visita llegará por mensaje de texto.',
    free_labs_book_visit: 'Reservar su visita al laboratorio',
    free_labs_book_visit_caption:
      'Es el mismo enlace que le enviamos por mensaje. Los resultados llegan por mensaje de texto o un proveedor de Tap se comunicará con usted.',
    free_labs_already_title: 'Hola {{name}}, todo está listo',
    free_labs_already_title_unnamed: 'Todo está listo',
    free_labs_already_subtitle:
      'Realizamos su pedido de análisis gratuito el {{date}}. Es un panel por persona, así que no hay nada más que enviar.',
    free_labs_already_book:
      'Es el mismo enlace que le enviamos por mensaje. Los resultados llegan por mensaje de texto o un proveedor de Tap se comunicará con usted.',
    free_labs_already_awaiting_requisition:
      'El laboratorio aún no ha emitido su orden. Le enviaremos el enlace de reserva en breve.',
    free_labs_already_results_pending:
      'Su muestra fue tomada. Le avisaremos por mensaje cuando sus resultados estén listos.',
    free_labs_already_released:
      'Sus resultados se enviaron por mensaje de texto. Revise sus mensajes para encontrar el enlace a los resultados.',
    free_labs_declined_outside_city_title: 'Esta dirección está fuera del área del programa',
    free_labs_declined_outside_city_body:
      'Los paneles gratuitos son para residentes dentro de los límites de las ciudades de Batavia, Aurora o Rolling Meadows. La dirección que ingresó queda fuera de ellos. Si es incorrecta, regrese y elija su dirección de nuevo.',
    free_labs_declined_quota_full_title: 'Se agotaron los paneles gratuitos en su área',
    free_labs_declined_quota_full_title_named: 'Se agotaron los paneles gratuitos para {{name}}',
    free_labs_declined_quota_full_body:
      'El programa cubre a un número limitado de residentes y ese límite se alcanzó. Hemos guardado sus datos.',
    free_labs_declined_duplicate_title: 'Ya se pidió un panel gratuito para usted',
    free_labs_declined_duplicate_body:
      'Es un panel por persona, así que no hay nada más que enviar. Revise sus mensajes de texto para encontrar su enlace de reserva o sus resultados.',
    free_labs_declined_address_unresolved_title: 'No pudimos ubicar su dirección en el mapa',
    free_labs_declined_address_unresolved_body:
      'Elija su dirección de las sugerencias para que podamos comprobar que está dentro del área del programa.',
    free_labs_declined_order_failed_title: 'No pudimos realizar su pedido',
    free_labs_declined_order_failed_body:
      'Algo salió mal del lado del laboratorio. Nuestro equipo fue notificado y le enviará un mensaje al {{phone}} para completar su pedido. No necesita hacer nada.',
    free_labs_fix_address: 'Corregir mi dirección',

    // Weight program (Foundayo)
    menu_weight_program: 'Programa de control de peso',
    weight_program_brand: 'Programa de peso',

    weight_program_intro_title: 'Foundayo para el control del peso',
    weight_program_intro_body:
      'Foundayo (orforglipron) es una pastilla diaria que se toma junto con un plan de alimentación y actividad física. Responda 10 preguntas breves para que un médico de Tap revise si puede ser adecuado para usted.',
    weight_program_intro_how_label: 'Cómo funciona',
    weight_program_intro_how_value: '10 preguntas → revisión médica → decisión',
    weight_program_intro_takes_label: 'Duración',
    weight_program_intro_takes_value: 'Unos 5 minutos',
    weight_program_intro_cost_label: 'Costo de la revisión',
    weight_program_intro_cost_value: 'Incluido en su atención de Tap',
    weight_program_intro_disclaimer:
      'Completar el formulario no garantiza una receta. Puede elegir "No estoy seguro" cuando necesite ayuda. El costo del medicamento y su disponibilidad en la farmacia se conversan con su médico.',
    weight_program_intro_start: 'Comenzar',
    weight_program_intro_start_failed: 'No pudimos iniciar el programa. Inténtelo de nuevo.',
    weight_program_how_title: 'Cómo funciona el programa',
    weight_program_how_step_review:
      'Un médico revisa su formulario inicial, confirma sus medidas y su historial de alimentación, acuerda con usted un objetivo de salud y aprueba el plan.',
    weight_program_how_step_first_dose:
      'Usted confirma el día en que toma su primera pastilla y, más adelante, el día en que comienza cada nueva dosis. Su médico puede comunicarse con usted 1 o 2 semanas después de comenzar o cambiar una dosis, o antes si tiene alguna inquietud.',
    weight_program_how_step_monthly:
      'Aproximadamente una vez al mes recibirá un breve formulario de seguimiento, con recordatorios si no lo completa.',
    weight_program_how_step_changes:
      'El médico revisa cada seguimiento antes de cualquier cambio en su receta. Si se omite una pregunta, el equipo de atención le dará seguimiento.',
    weight_program_how_step_goal:
      'Alcanzar su objetivo inicia una conversación sobre el mantenimiento. Si se suspende el medicamento, el médico acuerda el seguimiento y una forma de retomar la atención.',

    weight_program_consent_title: 'Antes de comenzar',
    weight_program_consent_body_review:
      'Sus respuestas se guardan en su expediente de Tap y las revisa un médico de Tap. Tap usa herramientas de IA para organizar sus respuestas para el médico; la IA no toma decisiones de tratamiento. Su médico decide sobre la elegibilidad, las recetas y cualquier cambio.',
    weight_program_consent_body_sms:
      'Los seguimientos mensuales forman parte de este programa. Le enviaremos por mensaje de texto un enlace a un formulario breve aproximadamente una vez al mes, con recordatorios si no lo completa.',
    weight_program_consent_ai_and_doctor_review:
      'Entiendo que un médico revisa mis respuestas y toma todas las decisiones de tratamiento, y que la IA se usa únicamente para organizar la información.',
    weight_program_consent_program_sms:
      'Acepto recibir mensajes de texto sobre este programa, incluidos los enlaces y recordatorios de los seguimientos mensuales.',
    weight_program_consent_continue: 'Continuar',
    weight_program_consent_accepted_on: 'Usted aceptó el {{date}}.',
    weight_program_consent_failed: 'No pudimos guardar sus consentimientos. Inténtelo de nuevo.',

    weight_program_submitted_title: 'Gracias. Sus respuestas están con su médico.',
    weight_program_submitted_body:
      'Un médico de Tap las revisará y le informará el siguiente paso. Este formulario no aprueba una receta.',
    weight_program_submitted_status_label: 'Estado',
    weight_program_submitted_status_value: 'Esperando la revisión del médico',
    weight_program_submitted_sent_label: 'Enviado',
    weight_program_submitted_answers_title: 'Sus respuestas',

    weight_program_eyebrow: 'Primeros pasos',
    weight_program_progress_label: 'Su progreso',
    weight_program_question_counter: 'Pregunta {{current}} de {{total}}',
    weight_program_review_title: 'Revise sus respuestas',
    weight_program_review_helper:
      'Puede volver atrás y cambiar lo que desee antes de enviar. Después de enviar, su médico revisa estas respuestas; los cambios se hacen por el chat.',
    weight_program_review_back: 'Volver a las preguntas',
    weight_program_submit: 'Enviar',
    weight_program_not_answered: 'Sin responder',
    weight_program_height_label: 'Su estatura',
    weight_program_weight_label: 'Su peso',
    weight_program_measured_on_label: '¿Cuándo se midió?',
    weight_program_problem_missing: 'Responda esta pregunta antes de continuar.',
    weight_program_problem_choose_one: 'Elija una opción.',
    weight_program_problem_exclusive_option: 'Esa opción no se puede combinar con las demás.',
    weight_program_problem_measurements_incomplete: 'Complete su estatura, su peso y la fecha.',
    weight_program_problem_measured_on_in_future: 'La fecha no puede ser futura.',
    weight_program_problem_detail_required: 'Indique sus medicamentos y suplementos.',
    weight_program_flag_title_emergency: 'Busque ayuda ahora',
    weight_program_flag_title_poison_control: 'Llame ahora a Control de Envenenamientos: 1-800-222-1222.',
    weight_program_flag_title_same_day: 'Su equipo de atención se comunicará con usted hoy.',
    weight_program_problem_inconsistent: 'Los días seguidos no pueden ser más que el total de días que omitió.',
    weight_program_save_failed: 'No pudimos guardar su respuesta. Revise su conexión e inténtelo de nuevo.',
    weight_program_submit_failed: 'No pudimos enviar sus respuestas. Inténtelo de nuevo.',
    weight_program_load_failed: 'No pudimos cargar su formulario. Inténtelo de nuevo.',
    weight_program_option_yes: 'Sí',
    weight_program_option_no: 'No',
    weight_program_option_not_sure: 'No estoy seguro',
    weight_program_option_none: 'Ninguno de estos',
    weight_program_helper_choose_all: 'Elija todas las que correspondan.',
    weight_program_body_measurements_title: '¿Cuál es su estatura y su peso?',
    weight_program_body_measurements_helper: 'Use una medición reciente.',
    weight_program_weight_related_conditions_title: '¿Algún médico le ha dicho que tiene alguna de estas afecciones?',
    weight_program_weight_related_conditions_option_hypertension: 'Presión arterial alta',
    weight_program_weight_related_conditions_option_high_cholesterol: 'Colesterol alto',
    weight_program_weight_related_conditions_option_type_2_diabetes: 'Diabetes tipo 2',
    weight_program_weight_related_conditions_option_sleep_apnea: 'Apnea del sueño',
    weight_program_weight_related_conditions_option_heart_disease: 'Enfermedad cardíaca',
    weight_program_reproductive_status_title: '¿Le aplica alguna de estas situaciones?',
    weight_program_reproductive_status_option_pregnant_or_possible: 'Estoy embarazada o podría estarlo',
    weight_program_reproductive_status_option_planning_pregnancy: 'Planeo quedar embarazada',
    weight_program_reproductive_status_option_breastfeeding: 'Estoy amamantando',
    weight_program_reproductive_status_option_oral_contraceptives: 'Tomo pastillas anticonceptivas',
    weight_program_reproductive_status_option_prefer_to_discuss: 'Prefiero hablarlo',
    weight_program_mtc_men2_history_title: '¿Usted o su familia han tenido CMT o MEN2?',
    weight_program_mtc_men2_history_helper:
      "CMT significa cáncer medular de tiroides, un tipo raro de cáncer de tiroides. MEN2 es una afección que causa tumores. Elija 'No estoy seguro' si necesita ayuda.",
    weight_program_glp1_allergy_title:
      '¿Ha tenido una alergia grave a Foundayo o a otro medicamento para el peso o la diabetes?',
    weight_program_glp1_allergy_detail_label: 'Nombre del medicamento (opcional)',
    weight_program_gi_organ_history_title: '¿Ha tenido alguno de estos problemas de salud?',
    weight_program_gi_organ_history_option_pancreatitis: 'Pancreatitis (inflamación del páncreas)',
    weight_program_gi_organ_history_option_gallstones: 'Cálculos biliares',
    weight_program_gi_organ_history_option_gastroparesis: 'Vaciamiento muy lento del estómago',
    weight_program_gi_organ_history_option_recurrent_vomiting: 'Vómitos repetidos',
    weight_program_gi_organ_history_option_kidney_disease: 'Enfermedad renal',
    weight_program_gi_organ_history_option_severe_liver_disease: 'Enfermedad hepática grave',
    weight_program_gi_organ_history_option_diabetic_retinopathy: 'Daño en los ojos por la diabetes',
    weight_program_eating_disorder_screen_title: '¿Ha tenido un trastorno alimentario o alguna de estas inquietudes?',
    weight_program_eating_disorder_screen_helper:
      'Elija todas las que correspondan, incluidas las del pasado. Sus respuestas nos ayudan a planificar su apoyo.',
    weight_program_eating_disorder_screen_option_anorexia_history:
      'Anorexia (restricción grave de la comida y miedo a subir de peso)',
    weight_program_eating_disorder_screen_option_bulimia_history:
      'Bulimia (atracones seguidos de intentos de compensarlos)',
    weight_program_eating_disorder_screen_option_binge_or_other_history:
      'Trastorno por atracón u otro trastorno alimentario',
    weight_program_eating_disorder_screen_option_restricting_from_fear:
      'Dejo de comer porque tengo miedo de subir de peso',
    weight_program_eating_disorder_screen_option_purging_or_compensating:
      'Vomito, uso laxantes o diuréticos, o hago ejercicio para compensar lo que como',
    weight_program_eating_disorder_screen_option_loss_of_control_eating: 'A veces siento que no puedo dejar de comer',
    weight_program_eating_disorder_screen_option_prefer_to_discuss: 'Prefiero hablar con mi profesional de salud',
    weight_program_eating_disorder_screen_detail_label:
      '¿Hay algo que quiera que su profesional de salud sepa? (opcional)',
    weight_program_current_medications_title: '¿Toma algún medicamento o suplemento?',
    weight_program_current_medications_helper:
      'Incluya insulina, medicamentos para la diabetes o el peso, productos comprados en línea, suplementos y anticonceptivos.',
    weight_program_current_medications_option_will_list: 'Sí',
    weight_program_current_medications_option_takes_none: 'No',
    weight_program_current_medications_option_need_help: 'Necesito ayuda con mi lista',
    weight_program_current_medications_detail_label: 'Sus medicamentos y suplementos',
    weight_program_planned_anesthesia_title: '¿Tiene planeada una cirugía o anestesia?',
    weight_program_planned_anesthesia_helper: 'La anestesia es un medicamento que lo duerme para un procedimiento.',
    weight_program_planned_anesthesia_date_label: 'Fecha, si la sabe (opcional)',
    weight_program_support_needs_title: '¿Con qué le gustaría recibir ayuda antes de empezar?',
    weight_program_support_needs_option_medicine_questions: 'Entender el medicamento',
    weight_program_support_needs_option_side_effects: 'Efectos secundarios',
    weight_program_support_needs_option_cost_or_access: 'Costo u obtención del medicamento',
    weight_program_support_needs_option_food_or_activity: 'Alimentación o actividad física',
    weight_program_support_needs_option_other: 'Otra cosa',
    weight_program_support_needs_option_ready_for_review: 'Estoy listo para la revisión del médico',
    weight_program_support_needs_detail_label: '¿Hay algo que quiera que su médico sepa? (opcional)',
    weight_program_decision_approved_title: 'Ya puede empezar: su solicitud fue aprobada',
    weight_program_decision_alternative_title: 'Su médico le sugiere otro tratamiento',
    weight_program_decision_not_appropriate_title: 'Foundayo no es la opción adecuada por ahora',
    weight_program_decision_status_approved: 'Aprobado',
    weight_program_decision_status_alternative: 'Tratamiento alternativo',
    weight_program_decision_status_not_appropriate: 'No adecuado',
    weight_program_decision_default_approved: 'Su médico revisó sus respuestas y aprobó que empiece con Foundayo.',
    weight_program_decision_default_alternative:
      'Su médico revisó sus respuestas y le sugiere un tratamiento diferente. Hablará con usted sobre los próximos pasos.',
    weight_program_decision_default_not_appropriate:
      'Su médico revisó sus respuestas y decidió que Foundayo no es la opción adecuada para usted por ahora.',
    weight_program_decision_reviewed_by_label: 'Revisado por',
    weight_program_decision_message_from: 'Mensaje del Dr. {{doctor}}',
    weight_program_decision_message_from_dated: 'Mensaje del Dr. {{doctor}} ({{date}})',
    weight_program_decision_message_from_your_doctor: 'Mensaje de su médico',
    weight_program_decision_doctor_name: 'Dr. {{doctor}}',
    weight_program_decision_start_again: 'Empezar de nuevo',
    weight_program_decision_status_awaiting_start: 'Pendiente de inicio',
    weight_program_decision_medicine_label: 'Su medicamento',
    weight_program_decision_prescription_label: 'Receta',
    weight_program_decision_prescription_sent: 'Enviada a su farmacia',
    weight_program_decision_prescription_preparing: 'Su médico la está preparando',
    weight_program_date_save: 'Guardar',
    weight_program_date_save_failed: 'No pudimos guardar la fecha. Inténtelo de nuevo.',
    weight_program_message_doctor: 'Enviar un mensaje a mi médico',
    weight_program_plan_note_from: 'Plan actual (Dr. {{doctor}}, {{date}})',
    weight_program_weight_title: 'Su peso',
    weight_program_history_title: 'Historial',
    weight_program_history_invited: 'Invitación al programa',
    weight_program_history_consents: 'Consentimientos aceptados',
    weight_program_history_form_sent: 'Preguntas de salud enviadas',
    weight_program_history_check_in_sent: 'Seguimiento enviado',
    weight_program_history_plan_updated_by: 'Plan actualizado por el Dr. {{doctor}}',
    weight_program_history_plan_updated: 'Plan actualizado',
    weight_program_history_first_dose: 'Primera pastilla',
    weight_program_history_dose_start: 'Inicio de una nueva dosis',
    weight_program_history_check_in_opened: 'Seguimiento disponible',
    weight_program_history_check_in_missed: 'Seguimiento no completado',
    weight_program_history_post_stop_check_in_sent: 'Seguimiento tras la suspensión enviado',
    weight_program_history_post_stop_check_in_opened: 'Seguimiento tras la suspensión disponible',
    weight_program_history_post_stop_check_in_missed: 'Seguimiento tras la suspensión no completado',
    weight_program_decision_type_approve_to_start: 'Aprobado para empezar',
    weight_program_decision_type_alternative_treatment: 'Tratamiento alternativo',
    weight_program_decision_type_not_appropriate: 'No adecuado',
    weight_program_decision_type_continue: 'Continuar',
    weight_program_decision_type_new_prescription: 'Nueva receta',
    weight_program_decision_type_hold: 'En pausa',
    weight_program_decision_type_stop: 'Suspendido',
    weight_program_decision_type_continue_post_stop: 'El seguimiento continúa',
    weight_program_decision_type_close: 'Programa cerrado',
    weight_program_first_dose_title: 'Avísenos cuando empiece',
    weight_program_first_dose_body:
      'Sus seguimientos mensuales se programan a partir del día en que toma su primera pastilla, no de la fecha de la receta. Puede cambiar la fecha hasta que se abra su primer seguimiento.',
    weight_program_first_dose_label: 'Fecha de su primera pastilla',
    weight_program_first_dose_change_label:
      'Fecha de su primera pastilla (puede cambiarla hasta que se abra su primer seguimiento)',
    weight_program_dose_start_title: 'Su médico actualizó su plan',
    weight_program_dose_start_decision_label: 'Decisión',
    weight_program_dose_start_plan_label: 'Nuevo plan',
    weight_program_dose_start_form_title: 'Avísenos cuando haga el cambio',
    weight_program_dose_start_label: 'Primer día con {{medicine}}',
    weight_program_check_in_due_title: 'Es hora de su seguimiento mensual',
    weight_program_check_in_due_body:
      '10 preguntas breves sobre su peso, su medicamento y cómo se siente. Su médico revisa cada seguimiento, incluso cuando todo está bien.',
    weight_program_check_in_label: 'Seguimiento',
    weight_program_check_in_cycle: 'Ciclo {{number}} · abierto el {{date}}',
    weight_program_plan_dose_label: 'Dosis actual',
    weight_program_plan_dose_since: '{{medicine}} desde el {{date}}',
    weight_program_check_in_last_weight_label: 'Último peso informado',
    weight_program_check_in_start: 'Comenzar seguimiento',
    weight_program_check_in_help:
      'Si tiene un problema nuevo antes de su próximo seguimiento, comuníquese con Tap por el chat en lugar de esperar al formulario mensual.',
    weight_program_check_in_submitted_title: 'Gracias. Su actualización está con su médico.',
    weight_program_check_in_submitted_body:
      'Un médico de Tap la revisará y le indicará el siguiente paso. Sus respuestas no cambian su receta.',
    weight_program_check_in_view_answers: 'Ver',
    weight_program_check_in_submitted_keep_taking:
      'Siga tomando su medicamento según lo recetado hasta que su médico le indique lo contrario. Si tiene un problema nuevo antes de su próximo seguimiento, comuníquese con Tap por el chat.',
    weight_program_treatment_title: 'Su plan de Foundayo',
    weight_program_on_hold_title: 'Su médico pausó el plan',
    weight_program_stopped_title: 'Su programa terminó',
    weight_program_status_on_treatment: 'En tratamiento',
    weight_program_status_on_hold: 'Pausado por su médico',
    weight_program_status_stopped: 'Suspendido',
    weight_program_status_post_stop: 'Medicamento suspendido · seguimiento',
    weight_program_post_stop_next_check_in: '{{date}} (seguimiento {{number}} de 2)',
    weight_program_post_stop_due_title: 'Es hora de un seguimiento breve',
    weight_program_post_stop_due_body:
      '5 preguntas breves sobre su peso y cómo se siente desde que dejó Foundayo. Su médico revisa cada seguimiento.',
    weight_program_post_stop_check_in_value: '{{number}} de 2 · responda antes del {{date}}',
    weight_program_post_stop_stopped_label: 'Medicamento suspendido',
    weight_program_post_stop_help:
      'Si tiene un problema nuevo, comuníquese con Tap por el chat en lugar de esperar al seguimiento.',
    weight_program_post_stop_submitted_body: 'Un médico de Tap la revisará y le indicará el siguiente paso.',
    weight_program_post_stop_eyebrow: 'Seguimiento tras la suspensión',
    weight_program_post_stop_wellbeing_title: '¿Cómo se siente desde que dejó el medicamento?',
    weight_program_post_stop_wellbeing_option_better: 'Mejor',
    weight_program_post_stop_wellbeing_option_same: 'Más o menos igual',
    weight_program_post_stop_wellbeing_option_worse: 'Peor',
    weight_program_post_stop_wellbeing_detail_label: '¿Qué cambió? (opcional)',
    weight_program_post_stop_eating_title: '¿Le preocupa algo sobre su alimentación o su apetito?',
    weight_program_post_stop_eating_option_none: 'No me preocupa nada',
    weight_program_post_stop_eating_option_concerned: 'Me preocupa mi alimentación o mi apetito',
    weight_program_post_stop_eating_option_prefer_to_discuss: 'Prefiero hablarlo',
    weight_program_post_stop_eating_detail_label: '¿Qué le preocupa? (opcional)',
    weight_program_post_stop_next_step_title: '¿Qué le gustaría hacer ahora?',
    weight_program_post_stop_next_step_option_fine: 'Estoy bien, no necesito nada más',
    weight_program_post_stop_next_step_option_talk_to_doctor: 'Quiero hablar con el médico',
    weight_program_post_stop_next_step_option_return_to_treatment:
      'Quiero hablar sobre volver a empezar el medicamento',
    weight_program_post_stop_next_step_detail_label: '¿Qué le gustaría que supiera su médico? (opcional)',
    weight_program_next_check_in_paused: 'En pausa, sin seguimiento programado',
    weight_program_plan_dose_start_label: 'Toma esta dosis desde',
    weight_program_plan_started_label: 'Inicio del programa',
    weight_program_plan_next_check_in_label: 'Próximo seguimiento',
    weight_program_monthly_eyebrow: 'Seguimiento mensual',
    weight_program_monthly_review_helper:
      'Puede volver atrás y cambiar lo que desee antes de enviar. Después de enviar, su médico revisa estas respuestas; los cambios se hacen por el chat.',
    weight_program_monthly_problem_weight_incomplete: 'Complete su peso, la unidad y la fecha.',
    weight_program_monthly_weight_title: '¿Cuál es su peso hoy?',
    weight_program_monthly_weight_helper: 'Use una medición reciente.',
    weight_program_monthly_weight_helper_previous:
      'Use una medición reciente. La última vez informó {{weight}} el {{date}}.',
    weight_program_monthly_weight_label: 'Peso de hoy',
    weight_program_monthly_dose_match_title: '¿Coincide con lo que está tomando?',
    weight_program_monthly_dose_match_helper: 'Su expediente indica {{medicine}} al día, iniciado el {{date}}.',
    weight_program_monthly_dose_match_helper_no_date: 'Su expediente indica {{medicine}} al día.',
    weight_program_monthly_dose_match_option_same: 'Sí, la dosis y la fecha son correctas',
    weight_program_monthly_dose_match_option_different: 'La dosis o la fecha de inicio es diferente',
    weight_program_monthly_dose_match_option_stopped: 'Dejé de tomarlo',
    weight_program_monthly_dose_match_option_not_started: 'No he empezado',
    weight_program_monthly_dose_match_detail_label:
      'Su dosis real, fecha de inicio o fecha de la última dosis (si la sabe)',
    weight_program_monthly_missed_days_title: '¿Cuántos días omitió su dosis este mes?',
    weight_program_monthly_missed_days_helper: 'Un número aproximado está bien si no lo recuerda con exactitud.',
    weight_program_monthly_missed_days_label: 'Total de días omitidos este mes',
    weight_program_monthly_missed_days_in_a_row_label: 'Máximo de días seguidos sin tomarla',
    weight_program_monthly_missed_days_summary: '{{count}} días en total, {{inARow}} seguidos',
    weight_program_monthly_appetite_title: '¿Cómo le ayuda el medicamento con el hambre y los antojos?',
    weight_program_monthly_appetite_option_helping: 'Me ayuda y aún puedo comer comidas normales',
    weight_program_monthly_appetite_option_still_hungry: 'El hambre o los antojos siguen siendo difíciles de controlar',
    weight_program_monthly_appetite_option_little_appetite: 'Tengo tan poco apetito que me cuesta comer',
    weight_program_monthly_appetite_option_no_change: 'No he notado ningún cambio',
    weight_program_monthly_side_effects_title: '¿Cuánto le han molestado los efectos secundarios?',
    weight_program_monthly_side_effects_helper:
      'Por ejemplo: náuseas, vómitos, diarrea, estreñimiento u otros síntomas nuevos.',
    weight_program_monthly_side_effects_option_none: 'Nada',
    weight_program_monthly_side_effects_option_mild: 'Leves, y puedo hacer mis actividades habituales',
    weight_program_monthly_side_effects_option_interfere: 'Afectan mi alimentación o mis actividades diarias',
    weight_program_monthly_side_effects_option_severe: 'Son graves',
    weight_program_monthly_side_effects_detail_label: '¿Qué efecto secundario y con qué frecuencia? (si lo sabe)',
    weight_program_monthly_eating_and_fluids_title: '¿Cómo le va con la comida, la bebida y las actividades diarias?',
    weight_program_monthly_eating_and_fluids_option_usual: 'Puedo comer, beber y hacer mis actividades habituales',
    weight_program_monthly_eating_and_fluids_option_hard_to_eat: 'Me cuesta comer comidas normales',
    weight_program_monthly_eating_and_fluids_option_hard_to_drink: 'Me cuesta beber suficiente líquido',
    weight_program_monthly_eating_and_fluids_option_cannot_keep_fluids: 'No puedo retener los líquidos',
    weight_program_monthly_eating_and_fluids_option_less_urine: 'Orino mucho menos de lo normal',
    weight_program_monthly_eating_and_fluids_option_weaker: 'Me siento más débil o las tareas diarias me cuestan más',
    weight_program_monthly_warning_signs_title: '¿Ha tenido alguna de estas señales de alarma?',
    weight_program_monthly_warning_signs_helper:
      'Elija todas las que correspondan. Si es una emergencia, busque ayuda ahora; no espere a terminar.',
    weight_program_monthly_warning_signs_option_persistent_belly_pain: 'Dolor fuerte de abdomen que no desaparece',
    weight_program_monthly_warning_signs_option_yellow_skin_or_eyes: 'Piel u ojos amarillos',
    weight_program_monthly_warning_signs_option_vision_trouble: 'Problemas nuevos de la vista',
    weight_program_monthly_warning_signs_option_neck_lump_or_hoarse:
      'Un bulto en el cuello o ronquera que no desaparece',
    weight_program_monthly_warning_signs_option_face_or_tongue_swelling: 'Hinchazón de la cara o la lengua',
    weight_program_monthly_warning_signs_option_trouble_breathing: 'Dificultad para respirar',
    weight_program_monthly_warning_signs_option_low_blood_sugar:
      'Azúcar baja en la sangre, temblores, sudoración, sensación de desmayo o confusión',
    weight_program_monthly_warning_signs_detail_label: '¿Cuándo ocurrió y qué notó? (opcional)',
    weight_program_monthly_changes_title: '¿Ha cambiado algo de esto desde su último seguimiento?',
    weight_program_monthly_changes_option_medicines: 'Medicamentos o suplementos nuevos, suspendidos o cambiados',
    weight_program_monthly_changes_option_health: 'Un nuevo problema de salud u otra cosa',
    weight_program_monthly_changes_option_pregnant: 'Estoy embarazada o podría estarlo',
    weight_program_monthly_changes_option_planning_pregnancy: 'Planeo quedar embarazada',
    weight_program_monthly_changes_option_breastfeeding: 'Estoy amamantando',
    weight_program_monthly_changes_option_birth_control_pills: 'Pastillas anticonceptivas',
    weight_program_monthly_changes_option_periods_changed:
      'Mi menstruación se detuvo o cambió de una forma que no puedo explicar',
    weight_program_monthly_changes_option_procedure_planned: 'Tengo planeada una cirugía o anestesia',
    weight_program_monthly_changes_option_none: 'Sin cambios',
    weight_program_monthly_changes_detail_label: 'Cuéntele un poco más a su médico (opcional)',
    weight_program_monthly_changes_reported_title: 'Medicamentos que indicó antes',
    weight_program_monthly_changes_reported_helper:
      'Esto es lo que nos dijo la última vez. Si algo cambió, elija la primera opción de abajo y actualice la lista.',
    weight_program_monthly_changes_medications_label: 'Sus medicamentos y suplementos ahora (obligatorio)',
    weight_program_monthly_changes_medications_helper:
      'Completamos su última lista. Agregue, quite o cambie lo que sea diferente ahora.',
    weight_program_monthly_changes_medications_summary: 'Medicamentos ahora: {{list}}',
    weight_program_monthly_eating_concerns_title: '¿Le ha pasado algo de esto este mes?',
    weight_program_monthly_eating_concerns_helper:
      'Elija todas las que correspondan. Se lo preguntamos a todos para poder apoyar un tratamiento seguro.',
    weight_program_monthly_eating_concerns_option_restricting_from_fear:
      'Dejo de comer porque tengo miedo de subir de peso',
    weight_program_monthly_eating_concerns_option_purging_or_compensating:
      'Vomito, uso laxantes o diuréticos, o hago ejercicio para compensar lo que como',
    weight_program_monthly_eating_concerns_option_loss_of_control_eating: 'A veces siento que no puedo dejar de comer',
    weight_program_monthly_eating_concerns_option_worries_interfere:
      'Las preocupaciones por la comida o el peso afectan mi vida diaria',
    weight_program_monthly_eating_concerns_option_dose_change_upsetting:
      'Reducir o dejar el medicamento me angustia mucho',
    weight_program_monthly_eating_concerns_option_took_extra: 'Tomé más medicamento del que me recetaron',
    weight_program_monthly_eating_concerns_option_other_source:
      'Usé un medicamento para el peso obtenido de otra fuente',
    weight_program_monthly_eating_concerns_option_prefer_to_discuss: 'Prefiero hablar con mi profesional de salud',
    weight_program_monthly_eating_concerns_detail_label: '¿Hay algo que quiera compartir? (opcional)',
    weight_program_monthly_plan_preference_title: '¿Qué le gustaría hablar sobre su plan?',
    weight_program_monthly_plan_preference_helper: 'Elija todas las que correspondan. Su respuesta no cambia su dosis.',
    weight_program_monthly_plan_preference_option_continue: 'Mantener el plan actual',
    weight_program_monthly_plan_preference_option_increase: 'Más ayuda para alcanzar mi objetivo o una dosis más alta',
    weight_program_monthly_plan_preference_option_decrease: 'Una dosis más baja o ayuda con los efectos secundarios',
    weight_program_monthly_plan_preference_option_maintain:
      'Estoy cerca de mi rango objetivo o dentro de él y quiero mantenerlo',
    weight_program_monthly_plan_preference_option_losing_too_much: 'Estoy bajando más de peso de lo que quiero',
    weight_program_monthly_plan_preference_option_need_goal: 'Necesito ayuda para fijar un objetivo',
    weight_program_monthly_plan_preference_option_stop: 'Dejar el medicamento o trasladar mi atención a otro lugar',
    weight_program_monthly_plan_preference_option_cost_or_access: 'Costo u obtención de mi medicamento',
    weight_program_monthly_plan_preference_option_question: 'Otra pregunta',
    weight_program_monthly_plan_preference_detail_label: '¿Qué le gustaría que su médico supiera? (opcional)',

    // Phone-first auth
    phone_auth_error_generic: 'Algo salió mal. Inténtalo de nuevo.',
    google_sign_in_error: 'No se pudo conectar con el servicio de autenticación de Google. Inténtalo de nuevo.',
    profile_updated_success: '¡Perfil actualizado correctamente!',
    phone_auth_error_rate_limited: 'Demasiados intentos, inténtalo de nuevo en unos minutos.',
    phone_auth_error_session_expired: 'Tu sesión de registro expiró. Empieza de nuevo.',
    phone_auth_error_code_invalid: 'Ese código no es correcto. Revísalo e inténtalo de nuevo.',
    phone_auth_error_code_expired: 'Ese código expiró. Solicita uno nuevo.',
    phone_auth_error_code_send_failed: 'No pudimos enviar el código. Inténtalo de nuevo.',
    phone_auth_error_patient_required: 'Esta cuenta aún no tiene un registro de paciente.',
    phone_auth_error_email_not_verified: 'Primero confirma tu correo electrónico.',
    phone_auth_error_patient_not_allowed: 'Este registro no está disponible para este número.',
    phone_auth_error_already_claimed: 'Este registro ya está vinculado a una cuenta. Inicia sesión.',
    phone_auth_error_already_registered: 'Ya estás registrado. Inicia sesión.',
    phone_auth_error_already_confirmed: 'Este número ya está confirmado.',
    phone_auth_error_dob_required: 'Ingresa tu fecha de nacimiento.',
    phone_auth_error_dob_mismatch:
      'La fecha de nacimiento que ingresaste no coincide con nuestros registros. Envíanos un mensaje de texto desde este teléfono y un proveedor revisará tus datos.',
    phone_auth_error_dob_attempts_exceeded:
      'Demasiados intentos incorrectos. Espera 20 minutos e inténtalo de nuevo, o envíanos un mensaje de texto desde este teléfono y un proveedor revisará tus datos.',
    phone_auth_error_must_be_adult: 'Debes tener al menos 18 años para crear una cuenta.',
    phone_auth_error_hipaa_required: 'Acepta el acuerdo de privacidad para continuar.',
    phone_auth_error_terms_required: 'Acepta los Términos de Uso y la Política de Privacidad para continuar.',
    phone_auth_error_same_number:
      'Este es tu propio número. Ingresa el número de teléfono personal de la otra persona adulta.',
    phone_auth_error_phone_required: 'Ingresa un número de teléfono.',
    phone_auth_error_number_has_account: 'Este número ya pertenece a una cuenta. Usa otro número.',
    phone_auth_error_register_by_phone:
      'No hay una cuenta para este correo de Google. Primero regístrate con tu número de teléfono.',
    phone_auth_invalid_phone: 'Ingresa un número de teléfono válido de EE. UU.',
    phone_auth_code_sent_to: 'Ingresa el código de 6 dígitos enviado a {{target}}.',
    phone_auth_resend: 'Enviar un código nuevo',
    phone_auth_resend_wait: 'Enviar un código nuevo ({{seconds}} s)',
    phone_auth_change_number: 'Usar otro número',
    phone_auth_change_email: 'Usar otro correo electrónico',
    phone_auth_verify_title: 'Verifica tu número de teléfono',
    phone_auth_login_title: 'Iniciar sesión',
    phone_auth_login_subtitle: 'Ingresa tu número de teléfono. Te enviaremos un código de un solo uso por SMS.',
    phone_auth_use_email_instead: 'Inicia sesión con tu correo electrónico',
    phone_auth_use_phone_instead: 'Inicia sesión con tu número de teléfono',
    phone_auth_email_login_title: 'Inicia sesión con tu correo electrónico',
    phone_auth_email_login_subtitle: 'Te enviaremos un código de un solo uso a tu correo electrónico.',
    phone_auth_check_email: 'Revisa tu correo electrónico',
    phone_auth_email_code_hint:
      'Si este correo electrónico está vinculado a una cuenta, enviamos un código. El código es válido por 10 minutos. Ingrésalo a continuación.',
    phone_auth_no_account_continue_phone: '¿Aún no tienes cuenta? Continúa con tu número de teléfono',
    phone_auth_no_account_title: 'Aún no tienes cuenta',
    phone_auth_no_account_text:
      'Tu número está verificado, pero no hay una cuenta para él. Ahora puedes crear tu perfil de paciente. Toma alrededor de un minuto.',
    phone_auth_create_profile: 'Crear mi perfil',
    phone_auth_create_account: 'Crea tu cuenta',
    phone_auth_register_title: 'Crea tu cuenta',
    phone_auth_register_subtitle:
      'Ingresa tu número de teléfono. Te enviaremos un código de un solo uso por SMS. No necesitas contraseña.',
    phone_auth_sign_in: 'Inicia sesión',
    phone_auth_account_exists_title: 'Ya tienes una cuenta',
    phone_auth_account_exists_text: 'Este número está vinculado a una cuenta existente, por eso iniciamos tu sesión.',
    phone_auth_choose_title: '¿Cuál es tu registro?',
    phone_auth_choose_subtitle:
      'Varias personas usan este número. Elige tu registro. Solo mostramos un nombre corto y el año de nacimiento.',
    phone_auth_choose_none: 'No estoy en esta lista, agrégame',
    phone_auth_choose_hint:
      '¿No reconoces a alguien de esta lista? Envíanos un mensaje de texto desde este teléfono para que podamos revisar el número.',
    phone_auth_found_title: 'Encontramos tu registro de paciente',
    phone_auth_found_subtitle:
      'Tu historial de atención se conectará a esta cuenta. Confirma tus datos para continuar.',
    phone_auth_profile_title: 'Crea tu perfil de paciente',
    phone_auth_profile_subtitle: 'No encontramos un registro de paciente existente para este número de teléfono.',
    phone_auth_add_email_title: 'Agrega tu correo electrónico',
    phone_auth_email_hint:
      'Tenemos un correo electrónico registrado que termina en {{hint}}. Ingrésalo para recibir el código o usa otro correo electrónico.',
    phone_auth_add_email_subtitle:
      'Tu correo electrónico es la forma alternativa de iniciar sesión si pierdes el acceso a tu número de teléfono.',
    phone_auth_heard_title: 'Una última pregunta',
    phone_auth_finish: 'Finalizar',
    phone_auth_skip: 'Omitir',
    phone_auth_profile_ready: 'Tu perfil está listo',
    phone_auth_invitation_invalid: 'Este enlace de invitación no es válido.',
    phone_auth_invitation_invalid_title: 'Este enlace de invitación ya no es válido',
    phone_auth_invitation_invalid_text:
      'Ya se usó o venció. Si ya configuraste tu cuenta, inicia sesión con tu número de teléfono. De lo contrario, pide a tu proveedor una nueva invitación.',
    phone_auth_invitation_title: 'Confirma tu número de teléfono',
    phone_auth_invitation_hint: 'Enviaremos un código al número de teléfono de tu registro que termina en {{hint}}.',
    phone_auth_invitation_another_number: 'Ya no es mi número',
    phone_auth_invitation_other_number:
      'Ingresa el número de teléfono que quieres usar. Te enviaremos un código de un solo uso por SMS.',
    phone_auth_invitation_no_number:
      'No hay un número de teléfono en tu registro. Ingresa el tuyo y te enviaremos un código de un solo uso por SMS.',
    phone_auth_invitation_use_record_number: 'Usar el número de mi registro',
    phone_auth_claim_invalid_link: 'Este enlace no es válido.',
    phone_auth_claim_hello: 'Hola, {{name}}',
    phone_auth_claim_subtitle: 'Confirma el número de teléfono que termina en {{hint}}. Se usará solo para ti.',
    phone_auth_claim_confirm: 'Confirmar',
    phone_auth_claim_done_title: 'Gracias, tu número está confirmado',
    phone_auth_claim_done_text: 'Ahora puedes iniciar sesión en el Portal del Paciente con este número.',
    phone_auth_claim_already_used: 'Este enlace ya fue utilizado.',
    phone_auth_add_phone_title: 'Agrega tu número de teléfono',
    phone_auth_add_phone_text: 'Ingresa tu número de teléfono. Te enviaremos un código de un solo uso por SMS.',
    phone_auth_add_phone_banner:
      'Tu cuenta aún no tiene un número de teléfono verificado. Agrégalo para iniciar sesión más rápido la próxima vez y para que podamos enviarte mensajes de texto sobre tu atención.',
    phone_auth_add_phone_cta: 'Agregar número',
    phone_auth_add_phone_done: 'Tu número de teléfono está verificado',
    phone_auth_shared_title: 'Otros adultos de tu hogar comparten este número',
    phone_auth_shared_text:
      'Cada adulto necesita su propio número para que podamos mantener su atención privada. Ingresa su número de teléfono y le enviaremos un mensaje de texto con un enlace para confirmarlo.',
    phone_auth_shared_cta: 'Ingresar su número',
    phone_auth_became_adult: '{{name}} ya es adulto',
    phone_auth_their_number: 'Su número de teléfono',
    phone_auth_send_link: 'Enviar enlace',
    phone_auth_has_login_note:
      'Este registro ya tiene una cuenta. Confirma tu fecha de nacimiento para iniciar sesión.',
    phone_auth_link_sent: 'Enlace enviado',
    // Google connect
    phone_auth_error_google_state_invalid: 'Esta confirmación de Google venció o ya se usó. Inténtalo de nuevo.',
    phone_auth_error_google_state_forbidden:
      'Esta confirmación de Google no pertenece a tu sesión actual. Inténtalo de nuevo.',
    phone_auth_error_google_email_unverified:
      'Google no ha verificado este correo electrónico. Usa otra cuenta de Google.',
    phone_auth_error_google_account_in_use: 'Esta cuenta de Google ya está conectada a otro inicio de sesión.',
    phone_auth_google_confirm: 'Confirmar con Google',
    google_cancelled: 'Se canceló el inicio de sesión con Google',
    google_session_missing: 'Inicia sesión e inténtalo de nuevo.',
    google_connected_success: 'Cuenta de Google conectada',
    google_email_changed_success: 'Tu correo electrónico de inicio de sesión se actualizó',
    signin_methods_load_error: 'No pudimos cargar tus métodos de inicio de sesión. Inténtalo de nuevo más tarde.',
    signin_methods_title: 'Métodos de inicio de sesión',
    signin_methods_phone: 'Número de teléfono',
    signin_methods_email: 'Correo electrónico',
    signin_methods_google: 'Google',
    signin_methods_verified: 'Verificado',
    signin_methods_not_confirmed: 'Sin confirmar',
    signin_methods_not_verified: 'Sin verificar',
    signin_methods_connected: 'Conectado',
    signin_methods_not_connected: 'No conectado',
    signin_methods_connected_since: 'desde el {{date}}',
    signin_methods_google_default: 'Funciona con el correo electrónico de tu cuenta',
    signin_methods_use_other_google: 'Usar otra cuenta de Google',
    signin_methods_connect_google: 'Conectar Google',
    signin_methods_not_set: 'No definido',
    google_email_change_title: 'Cambiar el correo de inicio de sesión',
    google_email_change_text: 'Tu correo electrónico de inicio de sesión cambiará de {{old}} a {{new}}. ¿Continuar?',
  },
}
